import {VectorImage, Tile as TileLayer, Image as ImageLayer, Group as LayerGroup} from './../../node_modules/ol/layer.js';
import { ImageStatic, VectorTile, Vector as VectorSource, TileArcGISRest, WMTS, TileWMS, ImageWMS, XYZ } from './../../node_modules/ol/source.js';
import TileImageSource from './../../node_modules/ol/source/TileImage.js';
import Point from './../../node_modules/ol/geom/Point.js';
import {register as proj4register} from './../../node_modules/ol/proj/proj4.js';
import {get as getProj,transformExtent} from './../../node_modules/ol/proj.js';
import GeoJOSNFormat from './../../node_modules/ol/format/GeoJSON.js';
import { TileGrid,createXYZ } from './../../node_modules/ol/tilegrid.js';
import WMTSCapabilities from './../../node_modules/ol/format/WMTSCapabilities.js';
import {optionsFromCapabilities} from './../../node_modules/ol/source/WMTS.js';
import bufferExtent from './bufferExtent.js';
import GML from './../../node_modules/ol/format/GML.js';
import GML2 from './../../node_modules/ol/format/GML2.js';
import GML3 from './../../node_modules/ol/format/GML3.js';
import GML32 from './../../node_modules/ol/format/GML32.js';
import WFSFormat from './../../node_modules/ol/format/WFS.js';
import { tile as tileStrategy} from './../../node_modules/ol/loadingstrategy.js';
import { intersects,getTopLeft,getCenter,getWidth } from './../../node_modules/ol/extent.js';
import EsriJSON from './../../node_modules/ol/format/EsriJSON.js';
import {deveverAjax} from './deveverAjax.js';
import {get as getConstants} from "../constants.js";
import generateLayerOptions from './generateLayerOptions.js';
import proj4 from './../../node_modules/proj4/dist/proj4.js';

const { defs: proj4defs } = proj4;

export default function generateLayer(layer, projectId, userIdentity) {

        var layer_types_string = getConstants('layer_types_string');

        var LayerOptions = generateLayerOptions(layer);

        var thissource = new VectorSource({
            crossOrigin: 'anonymous'
        });

        var VectorLayer = new VectorImage({
            name: LayerOptions.Name,
            source: thissource,
            visible: LayerOptions.VisibleAutmatically,
            zIndex: LayerOptions.zIndex,
            declutter: LayerOptions.Declutter,
        });

        if (LayerOptions.Type == 'Duplicated Layer') {

            VectorLayer.set('Id', LayerOptions.Id);
            VectorLayer.set('duplicateLayer', true);

        } else if (LayerOptions.noPermission) {

            VectorLayer.set('Id', LayerOptions.Id);
            VectorLayer.set('id', LayerOptions.Id);
            VectorLayer.set('AppId', LayerOptions.ApplicationId);
            VectorLayer.set('Type', LayerOptions.Type);
            VectorLayer.set('Name', LayerOptions.Name);

            if (metadataV1) {
                VectorLayer.set('Description', LayerOptions.Description);
            }

            VectorLayer.set('AliasName', LayerOptions.Name);
            VectorLayer.set('GrodanTitle', LayerOptions.SearchFieldTitle);
            VectorLayer.set('DataLocation', LayerOptions.DataLocation);
            VectorLayer.set('LayerContent', LayerOptions.StyleContent);
            VectorLayer.set('Transparency', LayerOptions.Transparency);
            VectorLayer.set('IsReadOnly', LayerOptions.IsReadOnly);
            VectorLayer.set('UseRender', LayerOptions.UseRender);
            VectorLayer.set('renderScaleGrodan', (LayerOptions.DefaultZoom != null ? LayerOptions.DefaultZoom : 1000));
            VectorLayer.set('ServerType', LayerOptions.ServerType);
            VectorLayer.set('Editable', LayerOptions.Editable);
            VectorLayer.set('isDrawable', LayerOptions.Editable);
            VectorLayer.set('isBaseMap', LayerOptions.isBaseMap);

            VectorLayer.set('TitleString', LayerOptions.TitleString);
            VectorLayer.set('ProjectId', LayerOptions.ProjectId);

            var settingsPermission = false;
            if (LayerOptions.ApplicationUserRole) {
                if (LayerOptions.ApplicationUserRole['PermissionLayer']['CanEditLayerSettings'] == true) {
                    settingsPermission = true;
                } else if (LayerOptions.ApplicationUserRole['PermissionLayer']['CanSeeLayerSettings'] == true) {
                    settingsPermission = true;
                }
            }

            var drawPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanDraw'] : false;
            var editPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanEdit'] : false;
            var modifyPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanModify'] : false;
            var deletePermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanDelete'] : false;

            var Permission = {
                Create: drawPermission,
                Edit: editPermission,
                Delete: deletePermission,
                Modify: modifyPermission,
                Settings: settingsPermission
            };

            VectorLayer.set('TextSymbolizerPropertyName', LayerOptions.TextSymbolizerPropertyName ?? "");
            VectorLayer.set('CategorizedFieldPropertyName', LayerOptions.CategorizedFieldPropertyName ?? "");

            VectorLayer.set('Permission', Permission);
            VectorLayer.set('NoAccess', LayerOptions.noPermission);

        } else {

            try {
                var selectedCacheName = `Ordered_${projectId}_${LayerOptions.Id}_${userIdentity}`;
                var selectedCachedIdsObj = localStorage.getItem(selectedCacheName);
                var selectedIds = null;

                var zoomToResult = false;

                if (selectedCachedIdsObj != null) {
                    try {
                        selectedCachedIdsObj = JSON.parse(selectedCachedIdsObj);
                        selectedIds = selectedCachedIdsObj['filtered'] == true ? selectedCachedIdsObj['Ids'].split(',') : null;

                    } catch (e) {

                    }
                }

                try {
                    if (ZoomTo['layerId'] == LayerOptions.Id && LayerOptions.SelectedByAttribute) {
                        selectedIds = null;
                    }

                    if (ZoomTo) {
                        if (ZoomTo['layerId'] == LayerOptions.Id && ZoomTo['Id'] != null) {
                            //selectedIds = [ZoomTo['Id']];
                            //zoomToResult = true;
                        }
                    }
                } catch (e) {

                }

                var epsg = '4326';

                if (LayerOptions.EPSG != 0 && LayerOptions.EPSG != 1111 && LayerOptions.EPSG != 84) {
                    epsg = LayerOptions.EPSG;
                }

                if (allProjs['EPSG:' + epsg]) {

                    registerProjection('EPSG:' + epsg);

                } else {

                    $.get('https://epsg.io/' + epsg + '.proj4', function (res) {
                        proj4defs('EPSG:' + epsg, res);
                        proj4register(proj4);
                    });

                }

                allEPSG[LayerOptions.Id] = epsg;

                if (LayerOptions.FeaturesAsGeoJson) {

                    var geojsonObject = LayerOptions.FeaturesAsGeoJson;
                    var features = readfeatures_with_proj('EPSG:' + epsg, mapProjection, geojsonObject, new GeoJOSNFormat());

                    if (LayerOptions.DataLocation.includes("Burials") == true) {
                        if (layers.map(l => l.Table).includes("Graves") == false) {
                            var vectorSource = new VectorSource({
                                crossOrigin: 'anonymous'
                            });
                            VectorLayer.setSource(vectorSource);
                            VectorLayer.set("graveFeatures", features);
                        }
                    }
                    else {
                        var vectorSource = new VectorSource({
                            features: features,
                            crossOrigin: 'anonymous'
                        });
                        VectorLayer.setSource(vectorSource);
                    }
                }

                VectorLayer.set('LayerContent', LayerOptions.StyleContent);

                if (LayerOptions.SelectedFeaturesAsJson !== null && LayerOptions.SelectedFeaturesAsJson != "[]") {
                    var SelectedFeaturesAsJson = JSON.parse(LayerOptions.SelectedFeaturesAsJson);

                    if (SelectedFeaturesAsJson.length == 1) {

                        var item = SelectedFeaturesAsJson[0];

                        if (selectedIds != null) {
                            if (!selectedIds.includes(item.Id.toString())) {
                                item.WKT = false;
                            }
                        }

                        if (item.WKT) {
                            var feature1 = readfeature_with_proj('EPSG:' + epsg, mapProjection, item.WKT, writer);
                            feature1.setId(item.Id.toString());
                            feature1.set('Id', item.Id.toString());
                            feature1.set('layerId', item.layerId);
                            feature1.set('projectId', projectId);
                            feature1.set('TitleSelectedgrodan', item.Title);

                            var seletedFeature1 = feature1;

                            if (ZoomTo) {
                                if (ZoomTo['layerId'] == LayerOptions.Id && (ZoomTo['Id'] == item.Id || ZoomTo['Id'] == null)) {
                                    if (seletedFeature1 != null && seletedFeature1) {
                                        var extent11 = seletedFeature1.getGeometry().getExtent();
                                        extent11 = bufferExtent(extent11);
                                        map.getView().fit(extent11);
                                        if (seletedFeature1.getGeometry() instanceof Point) {
                                            var defzo = LayerOptions.DefaultZoom != null ? LayerOptions.DefaultZoom : 1000;
                                            zoomLevel = defzo;
                                            extentToZoom = extent11;
                                            hasSelectedFeatures = true;
                                            isonlyPoint = true;
                                        }
                                        else {
                                            if (hasSelectedFeatures === false) {

                                                hasSelectedFeatures = true;
                                                extentToZoom = extent11;
                                            }

                                        }

                                    }
                                }
                            } else {

                                if (seletedFeature1 != null && seletedFeature1) {
                                    var extent11 = seletedFeature1.getGeometry().getExtent();
                                    extent11 = bufferExtent(extent11);
                                    map.getView().fit(extent11);
                                    if (seletedFeature1.getGeometry() instanceof Point) {
                                        var defzo = LayerOptions.DefaultZoom != null ? LayerOptions.DefaultZoom : 1000;
                                        zoomLevel = defzo;
                                        extentToZoom = extent11;
                                        hasSelectedFeatures = true;
                                        isonlyPoint = true;
                                    }
                                    else {
                                        if (hasSelectedFeatures === false) {

                                            hasSelectedFeatures = true;
                                            extentToZoom = extent11;
                                        }

                                    }

                                }

                            }

                            var lname = LayerOptions.Id;

                            if (selectedFeatures[lname]) {
                                var te = false;
                                selectedFeatures[lname]['features'].forEach((feat, ind) => {
                                    if (feat == seletedFeature1) {
                                        te = true;
                                    }
                                });
                                if (!te) {
                                    selectedFeatures[lname]['features'] = [seletedFeature1];
                                }
                            }
                            else {
                                selectedFeatures[lname] = {
                                    Id: LayerOptions.Id,
                                    DataLocation: LayerOptions.DataLocation,
                                    AppId: LayerOptions.ApplicationId,
                                    name: LayerOptions.Name
                                };
                                selectedFeatures[lname]['features'] = [seletedFeature1];
                            }
                            myalllayers['isActive'] = VectorLayer;

                            //$("#selectedlayer").prop("name", VectorLayer.get('Id'));
                            //$("#selectedlayer").text(VectorLayer.get('name'));
                            //$('#layersearchinput').attr('placeholder', LayerOptions.SearchFieldTitle);

                            //select_inter_source.addFeature(seletedFeature1);

                            //workwithselectedfeatures(selectedFeatures[VectorLayer.get('name')], VectorLayer.get('name'), false, lastSelectedFeatures);

                            changefieldtoinfo(VectorLayer);

                        }
                    }
                    else {
                        var selectedeW = [];
                        SelectedFeaturesAsJson.forEach((item) => {
                            if (item.WKT) {

                                if (selectedIds != null) {
                                    if (!selectedIds.includes(item.Id.toString())) {
                                        return null;
                                    }
                                }

                                var feature1 = readfeature_with_proj('EPSG:' + epsg, mapProjection, item.WKT, writer);
                                feature1.setId(item.Id.toString());
                                feature1.set('Id', item.Id.toString());
                                feature1.set('layerId', item.layerId);
                                feature1.set('projectId', projectId);
                                feature1.set('TitleSelectedgrodan', item.Title);
                                selectedeW.push(feature1);


                                if (ZoomTo) {
                                    if (ZoomTo['layerId'] == LayerOptions.Id && ZoomTo['Id'] == item.Id) {
                                        var seletedFeature1 = feature1;
                                        if (seletedFeature1 != null && seletedFeature1) {
                                            var extent11 = seletedFeature1.getGeometry().getExtent();
                                            extent11 = bufferExtent(extent11);
                                            map.getView().fit(extent11);
                                            if (seletedFeature1.getGeometry() instanceof Point) {
                                                var defzo = LayerOptions.DefaultZoom != null ? LayerOptions.DefaultZoom : 1000;
                                                zoomLevel = defzo;
                                                extentToZoom = extent11;
                                                hasSelectedFeatures = true;
                                                isonlyPoint = true;
                                            }
                                            else {
                                                if (hasSelectedFeatures === false) {

                                                    hasSelectedFeatures = true;
                                                    extentToZoom = extent11;
                                                }

                                            }

                                        }
                                    }
                                }
                            }
                        });

                        var lname = LayerOptions.Id;

                        if (selectedFeatures[lname]) {

                            selectedFeatures[lname]['features'] = selectedeW;

                        } else {
                            selectedFeatures[lname] = {
                                Id: LayerOptions.Id,
                                DataLocation: LayerOptions.DataLocation,
                                AppId: LayerOptions.ApplicationId,
                                name: LayerOptions.Name
                            };
                            selectedFeatures[lname]['features'] = selectedeW;
                        }
                        myalllayers['isActive'] = VectorLayer;

                        select_inter_source.addFeatures(selectedeW);

                        if (ZoomTo) {
                            if (ZoomTo['layerId'] == LayerOptions.Id && ZoomTo['Id'] == null) {

                                var extent11 = select_inter_source.getExtent();
                                extent11 = bufferExtent(extent11);
                                if (extent11[0] != Infinity) {

                                    map.getView().fit(extent11);
                                    if (hasSelectedFeatures === false) {

                                        hasSelectedFeatures = true;
                                        extentToZoom = extent11;
                                    }
                                }

                            }
                        }

                        changefieldtoinfo(VectorLayer);

                    }
                }

                if (hasSelectedFeatures === false && localMapData) {
                    if (LayerOptions.Id == localMapData['activeLayer']) {
                        myalllayers['isActive'] = VectorLayer;
                    }
                }

                var fieldsforsearch = [];

                if (LayerOptions.SearchFieldNamesAndIds) {
                    var searchfields = LayerOptions.SearchFieldNamesAndIds.split('*/');
                    searchfields.forEach(searchfield => {
                        fieldsforsearch.push({
                            id: searchfield.split('-')[1],
                            aliasname: searchfield.split('-')[0]
                        });
                    });
                }

                VectorLayer.set('searchFields', fieldsforsearch);

                if (LayerOptions.Type === layer_types_string.ModuleLayer || LayerOptions.Type === layer_types_string.ToolLayer) {
                    if (LayerOptions.Symbolizers) {
                        workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, true, layer);
                        realindex++;
                    }

                    myalllayers.vectore.push(VectorLayer);

                    if (hasModule === false && hasSelectedFeatures === false && typeof (localMapData) == undefined) {
                        VectorLayer.set('isLocal', true);
                        //VectorLayer.set('isActive', true);
                        //myalllayers.isActive = VectorLayer;

                        lastactivelayercontent = LayerOptions.StyleContent;

                        if (VectorLayer.getSource().getFeatures().length > 0) {
                            extent = VectorLayer.getSource().getExtent();
                            extent = bufferExtent(extent);
                            if (hasSelectedFeatures === false) {
                                hasModule = true;
                                extentToZoom = extent;
                            }
                        }

                        searchfieldsappend(VectorLayer);
                    }
                }
                else if (LayerOptions.Type === layer_types_string.ServiceLayer) {

                    if (false) {

                        //512 tileSize
                        const projExtent = getProj(mapProjection).getExtent();
                        const startResolution = getWidth(projExtent) / 512;
                        const resolutions = new Array(22);
                        for (let i = 0, ii = resolutions.length; i < ii; ++i) {
                            resolutions[i] = startResolution / Math.pow(2, i);
                        }
                        const tileGrid512 = new TileGrid({
                            extent: projExtent,
                            tileSize: [512, 512],
                            resolutions: resolutions,
                        });

                    }

                    var wmsSource;
                    if (LayerOptions.ServerType == 'arcgis') {

                        wmsSource = new TileArcGISRest({
                            url: LayerOptions.ServerURL + '&' + LayerOptions.AdditionalParameters,
                            params: {
                                'LAYERS': 'show:' + LayerOptions.Layers,
                                'TRANSPARENT': true
                            },
                            projection: 'EPSG:' + epsg,
                        });

                    } else if (LayerOptions.ServerType == 'wmts') {

                        var fired = false;
                        const req = new XMLHttpRequest();
                        req.onload = (res) => {

                            var text = req.responseText;
                            const result = (new WMTSCapabilities()).read(text);

                            var optionsWMTS = optionsFromCapabilities(result, {
                                layer: LayerOptions.Layers,
                                projection: 'EPSG:' + epsg,
                            });

                            wmsSource = new WMTS(optionsWMTS);

                            wmsSource.on('tileloadstart', function () {
                                progress.addLoading();
                            });

                            wmsSource.on('tileloadend', function () {
                                progress.addLoaded();
                            });
                            wmsSource.on('tileloaderror', function () {
                                progress.addLoaded();
                            });

                            VectorLayer.setSource(wmsSource);
                        };
                        req.onerror = (r) => {
                            if (!fired) {
                                req.open("GET", "https://cors-anywhere.herokuapp.com/" + LayerOptions.ServerURL, true);
                                req.send();
                            }
                        }
                        req.open("GET", LayerOptions.ServerURL + '&' + LayerOptions.AdditionalParameters);
                        req.send();

                        //fetch(LayerOptions.ServerURL)
                        //    .then(function (response) {
                        //        return response.text();
                        //    })
                        //    .then(function (text) {
                        //        const result = (new WMTSCapabilities()).read(text);
                        //        var optionsWMTS = optionsFromCapabilities(result, {
                        //            layer: LayerOptions.Layers,
                        //            matrixSet: 'EPSG:' + epsg,
                        //        });

                        //        wmsSource = new WMTS(optionsWMTS);

                        //        wmsSource.on('tileloadstart', function () {
                        //            progress.addLoading();
                        //        });

                        //        wmsSource.on('tileloadend', function () {
                        //            progress.addLoaded();
                        //        });
                        //        wmsSource.on('tileloaderror', function () {
                        //            progress.addLoaded();
                        //        });

                        //        VectorLayer.setSource(wmsSource);
                        //    });

                        const proxyurl = "https://cors-anywhere.herokuapp.com/";

                        wmsSource = new TileWMS();
                    } else {
                        if (LayerOptions.Authorization != null && LayerOptions.Authorization != '') {

                            function tileLoadFunction(tile, src) {

                                const useAjax = true;

                                if (useAjax) {

                                    deveverAjax({
                                        type: "GET",
                                        url: src,
                                        customHeader: { key: "Authorization", value: LayerOptions.Authorization },
                                        dataType: 'arraybuffer',
                                        loaderTimeInMs: 10000000000,
                                        success: function (response) {
                                            const arrayBufferView = new Uint8Array(response);
                                            const blob = new Blob([arrayBufferView], { type: 'image/png' });
                                            const urlCreator = window.URL;
                                            const imageUrl = urlCreator.createObjectURL(blob);
                                            tile.getImage().src = imageUrl;

                                            tile.getImage().onload = function () {
                                                tile.setState(2);
                                            }

                                            tile.getImage().onerror = function () {
                                                tile.setState(3);
                                            }

                                        }, error: function (res) {
                                            tile.setState(3);
                                        }
                                    });

                                } else {

                                    var client = new XMLHttpRequest();

                                    client.open('GET', src);
                                    client.responseType = 'arraybuffer';
                                    client.setRequestHeader('Authorization', LayerOptions.Authorization);
                                    client.onload = function () {
                                        const arrayBufferView = new Uint8Array(this.response);
                                        const blob = new Blob([arrayBufferView], { type: 'image/png' });
                                        const urlCreator = window.URL;
                                        const imageUrl = urlCreator.createObjectURL(blob);
                                        tile.getImage().src = imageUrl;

                                        tile.getImage().onload = function () {
                                            tile.setState(2);
                                        }

                                        tile.getImage().onerror = function () {
                                            tile.setState(3);
                                        }

                                    };
                                    client.onerror = function () {
                                        tile.setState(3);
                                    }

                                    client.showLoader = false;

                                    client.send();
                                }
                            }

                            wmsSource = new TileWMS({
                                url: LayerOptions.ServerURL + '&' + LayerOptions.AdditionalParameters,
                                tileLoadFunction: tileLoadFunction,
                                params: {
                                    //'TILED': true,
                                    //'FORMAT': 'image/png',
                                    'LAYERS': LayerOptions.Layers,
                                    'VERSION': LayerOptions.Version,
                                    'TRANSPARENT': true
                                },
                                serverType: LayerOptions.ServerType,
                                projection: 'EPSG:' + epsg,
                                wrapX: false
                            });

                            //Single Image layer
                            if (LayerOptions.TileSize == 1) {

                                function tileLoadFunction(tile, src) {

                                    const useAjax = true;

                                    if (useAjax) {

                                        deveverAjax({
                                            type: "GET",
                                            url: src,
                                            customHeader: { key: "Authorization", value: LayerOptions.Authorization },
                                            dataType: 'arraybuffer',
                                            loaderTimeInMs: 10000000000,
                                            success: function (response) {
                                                const arrayBufferView = new Uint8Array(response);
                                                const blob = new Blob([arrayBufferView], { type: 'image/png' });
                                                const urlCreator = window.URL;
                                                const imageUrl = urlCreator.createObjectURL(blob);
                                                tile.getImage().src = imageUrl;

                                                tile.getImage().onload = function () {
                                                    tile.setState(2);
                                                }

                                                tile.getImage().onerror = function () {
                                                    tile.setState(3);
                                                }

                                            }, error: function (res) {
                                                tile.setState(3);
                                            }
                                        });

                                    } else {

                                        var client = new XMLHttpRequest();

                                        client.open('GET', src);
                                        client.responseType = 'arraybuffer';
                                        client.setRequestHeader('Authorization', LayerOptions.Authorization);
                                        client.onload = function () {
                                            const arrayBufferView = new Uint8Array(this.response);
                                            const blob = new Blob([arrayBufferView], { type: 'image/png' });
                                            const urlCreator = window.URL;
                                            const imageUrl = urlCreator.createObjectURL(blob);
                                            tile.getImage().src = imageUrl;

                                            tile.getImage().onload = function () {
                                                tile.setState(2);
                                            }

                                            tile.getImage().onerror = function () {
                                                tile.setState(3);
                                            }

                                        };
                                        client.onerror = function () {
                                            tile.setState(3);
                                        }

                                        client.showLoader = false;

                                        client.send();
                                    }
                                }

                                wmsSource = new ImageWMS({
                                    ratio: 1,
                                    url: callUrl,
                                    imageLoadFunction: tileLoadFunction,
                                    params: {
                                        //'TILED': true,
                                        //'FORMAT': 'image/png',
                                        'LAYERS': LayerOptions.Layers,
                                        'VERSION': LayerOptions.Version,
                                        'TRANSPARENT': true
                                    },
                                    serverType: LayerOptions.ServerType,
                                    projection: 'EPSG:' + epsg,
                                    wrapX: false
                                });
                            }


                            //wmsSource.on('tileloaderror', function () {
                            //    console.log('tile error');
                            //})
                            //wmsSource.on('tileloadend', function () {
                            //    console.log('end');
                            //})
                        }
                        else {

                            function tileLoadFunction(tile, src) {
                                //var url = src;
                                //fabric.Image.fromURL(url, function (img) {
                                //    canvas.add(img);
                                //    // call toDataURL after image gets loaded
                                //    console.log(canvas.toDataURL());
                                //});
                                //var canvas = new fabric.Canvas('canvas');
                                //fabric.util.loadImage(src,
                                //    function (img) {
                                //        var fab_image = new fabric.Image(img);
                                //        canvas.add(fab_image);
                                //        canvas.renderAll();
                                //        console.log(canvas.toDataURL());
                                //    }, { left: 0, top: 0, }
                                //);

                                tile.getImage().src = src;

                                tile.getImage().onload = function () {
                                    tile.setState(2);
                                }

                                tile.getImage().onerror = function () {
                                    tile.setState(3);
                                }

                                //const client = new XMLHttpRequest();

                                //client.showLoader = false;

                                //client.open('GET', src);
                                //client.responseType = 'arraybuffer';

                                //client.onload = function () {
                                //    const arrayBufferView = new Uint8Array(this.response);
                                //    const blob = new Blob([arrayBufferView], { type: 'image/png' });
                                //    const urlCreator = window.URL;
                                //    const imageUrl = urlCreator.createObjectURL(blob);
                                //    tile.getImage().src = imageUrl;
                                //};
                                //client.onerror = function () {
                                //    tile.setState(3);
                                //}

                                //client.send();

                            }

                            var callUrl = LayerOptions.ServerURL + '&' + LayerOptions.AdditionalParameters;

                            wmsSource = new TileWMS({
                                url: callUrl,
                                tileLoadFunction: tileLoadFunction,
                                params: {
                                    //'TILED': true,
                                    //'FORMAT': 'image/png',
                                    'LAYERS': LayerOptions.Layers,
                                    'VERSION': LayerOptions.Version,
                                    'TRANSPARENT': true
                                },
                                serverType: LayerOptions.ServerType,
                                projection: 'EPSG:' + epsg,
                                wrapX: false
                            });

                            //Single Image layer
                            if (LayerOptions.TileSize == 1) {

                                function tileLoadFunction(tile, src) {

                                    tile.getImage().src = src;

                                }

                                wmsSource = new ImageWMS({
                                    ratio: 1,
                                    url: callUrl,
                                    imageLoadFunction: tileLoadFunction,
                                    params: {
                                        //'TILED': true,
                                        //'FORMAT': 'image/png',
                                        'LAYERS': LayerOptions.Layers,
                                        'VERSION': LayerOptions.Version,
                                        'TRANSPARENT': true
                                    },
                                    serverType: LayerOptions.ServerType,
                                    projection: 'EPSG:' + epsg,
                                    wrapX: false
                                });
                            }

                        }
                    }

                    wmsSource.on('tileloadstart', function () {

                        if (wmsLayersErrorCountVerstion == 1) {

                            var errCount = wmsSource.get('ErrorCount');

                            if (errCount > 10) {
                                makeLayerInvisible();
                            }

                        }

                        progress.addLoading();
                    });

                    wmsSource.on('tileloadend', function () {

                        if (wmsLayersErrorCountVerstion == 1) {

                            wmsSource.set('ErrorCount', 0);

                        }

                        progress.addLoaded();
                    });

                    wmsSource.on('tileloaderror', function () {

                        if (wmsLayersErrorCountVerstion == 1) {

                            var ErrorCount = wmsSource.get('ErrorCount') ? wmsSource.get('ErrorCount') + 1 : 1;
                            wmsSource.set('ErrorCount', ErrorCount);

                            if (ErrorCount > 10) {
                                makeLayerInvisible();
                            }

                        }

                        progress.addLoaded();
                    });

                    VectorLayer = new TileLayer({
                        visible: LayerOptions.VisibleAutmatically,
                        name: LayerOptions.Name,
                        zIndex: LayerOptions.zIndex,
                        minResolution: minRes,
                        maxResolution: maxRes,
                        source: wmsSource
                    });

                    //Single Image layer
                    if (LayerOptions.TileSize == 1) {
                        VectorLayer = new ImageLayer({
                            visible: LayerOptions.VisibleAutmatically,
                            name: LayerOptions.Name,
                            zIndex: LayerOptions.zIndex,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            source: wmsSource
                        });
                    }

                    function makeLayerInvisible() {
                        if (wmsSource.set('SourceEndError') != true) {

                            var activeId = $('#' + VectorLayer.get('checkbox'));

                            var parentContainer = $(activeId).parents('div.layer-container');

                            if (VectorLayer.get('groupLayer')) {
                                var removedLs = VectorLayer.get('groupLayer').get('removedLayerIds') ? VectorLayer.get('groupLayer').get('removedLayerIds') : [];
                                removedLs.push(VectorLayer.get('Id'));
                                VectorLayer.get('groupLayer').getLayers().remove(VectorLayer);

                                parentContainer.find('input[type="checkbox"].Layer__Checkbox').removeClass('layer' + (VectorLayer.get('groupLayer').get('Id')).replace('g', ''));
                            } else {
                                map.removeLayer(VectorLayer);
                            }

                            if (parentContainer.find('a.source-end-error').length == 0) {
                                parentContainer.append(`<a class="source-end-error" href="javascript:void(0);" style="position:absolute; left: -1rem; top: 0.25rem;" title="${NamesForLanguages.titles.layer_backend_error}"><i class="fas fa-triangle-exclamation" style="color: rgba(255,0,0,0.5);"></i></a>`);
                            } else {
                            }

                            parentContainer.find('input[type="checkbox"].Layer__Checkbox').prop('checked', false);
                            parentContainer.find('input[type="checkbox"].Layer__Checkbox').prop('disabled', true);

                        }
                        wmsSource.set('SourceEndError', true);
                    }

                    if (LayerOptions.Extent != null) {
                        var extt = LayerOptions.Extent.split('(')[0].split(',');
                        extt = halfOfExtent(extt);
                        extt = halfOfExtent(extt);
                        extt = halfOfExtent(extt);
                        extt = halfOfExtent(extt);
                        extt = halfOfExtent(extt);
                        var epsg1 = epsg;
                        if (LayerOptions.ServerType == 'arcgis') {
                            var myurl = LayerOptions.ServerURL + '/export?F=image&FORMAT=PNG32&TRANSPARENT=true&SIZE=1%2C1&BBOX=' + extt[0] + '%2C' + extt[1] + '%2C' + extt[2] + '%2C' + extt[3] + '&BBOXSR=' + epsg1 + '&IMAGESR=' + epsg1 + '&DPI=90&LAYERS=show' + encodeURI(':' + LayerOptions.Layers) + '&' + LayerOptions.AdditionalParameters;
                            var xhttp = new XMLHttpRequest();
                            xhttp.onreadystatechange = function (oEvent) {
                                if (xhttp.readyState === 4) {
                                    if (xhttp.status === 200) {
                                        VectorLayer.getSource().crossOrigin = 'Anonymous';
                                        $('#notprintable-' + LayerOptions.Id).empty();
                                    } else {
                                        //xhttp.open("GET", "https://cors-anywhere.herokuapp.com/" + myurl);
                                        //xhttp.onreadystatechange = function (oEvent) {
                                        //    if (xhttp.readyState === 4) {
                                        //        console.log(LayerOptions.Name)
                                        //        if (xhttp.status === 200) {
                                        //            console.log('not pritable');
                                        //        } else {
                                        //            console.log('not readable');
                                        //            //disable not printable layer
                                        //            VectorLayer.setVisible(false);
                                        //            $('#' + VectorLayer.get('checkbox')).prop({ 'disabled': true, 'checked': false });
                                        //            localLayerDatas[LayerOptions.Id]['visible'] = false;
                                        //        }
                                        //    }
                                        //};
                                        //xhttp.send();
                                    }
                                }
                            };
                            xhttp.open("GET", myurl);
                            xhttp.send();
                        } else if (LayerOptions.ServerType == 'wmts') {

                        }
                        else {
                            var myurl = LayerOptions.ServerURL + 'SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=' + LayerOptions.Layers + '&WIDTH=1&HEIGHT=1&CRS=EPSG%3A' + epsg1 + '&STYLES=&BBOX=' + extt[0] + '%2C' + extt[1] + '%2C' + extt[2] + '%2C' + extt[3] + '&' + LayerOptions.AdditionalParameters;
                            var xhttp = new XMLHttpRequest();
                            xhttp.onreadystatechange = function (oEvent) {
                                if (xhttp.readyState === 4) {
                                    if (xhttp.status === 200) {
                                        VectorLayer.getSource().crossOrigin = 'Anonymous';
                                        $('#notprintable-' + LayerOptions.Id).empty();
                                    } else {
                                        //xhttp.open("GET", "https://cors-anywhere.herokuapp.com/" + myurl);
                                        //xhttp.onreadystatechange = function (oEvent) {
                                        //    if (xhttp.readyState === 4) {
                                        //        console.log(LayerOptions.Name)
                                        //        if (xhttp.status === 200) {
                                        //            console.log('not pritable');
                                        //        } else {
                                        //            console.log('not readable');
                                        //            //disable not printable layer
                                        //            VectorLayer.setVisible(false);
                                        //            $('#' + VectorLayer.get('checkbox')).prop({ 'disabled': true, 'checked': false });
                                        //            localLayerDatas[LayerOptions.Id]['visible'] = false;
                                        //        }
                                        //    }
                                        //};
                                        //xhttp.send();
                                    }
                                }
                            };
                            xhttp.open("GET", myurl);
                            if (LayerOptions.Authorization != null && LayerOptions.Authorization != '') {
                                xhttp.setRequestHeader('Authorization', LayerOptions.Authorization);
                            }
                            xhttp.send();
                        }
                    }

                    if (LayerOptions.zIndex) {
                        VectorLayer.setZIndex(LayerOptions.zIndex);
                    }

                    if (LayerOptions.Symbolizers) {

                        if (LayerOptions.LegendURL != '' && LayerOptions.LegendURL != null) {
                            workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, false, layer, LayerOptions.LegendURL);
                        } else if (VectorLayer.getSource().getLegendUrl && LayerOptions.ServerType != 'wmts') {
                            workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, false, layer, VectorLayer.getSource().getLegendUrl());
                        } else {
                            if (LayerOptions.ServerType == 'arcgis') {
                                var myla;
                                $.get(LayerOptions.ServerURL + '/legend?f=pjson' + '&' + LayerOptions.AdditionalParameters, function (res) {
                                    var jsonr = JSON.parse(res);
                                    myla = jsonr['layers'].find(x => x['layerId'] == LayerOptions.Layers);
                                    if (myla) {
                                        myla = myla['legend']
                                        var mydiv = '';
                                        myla.forEach((legend, ind) => {
                                            mydiv += '<div><img src="data:image/png;base64, ' + legend['imageData'] + '" /><label>' + legend['label'] + '</label></div>';
                                        });
                                        $('#layer-home div.arcgis_legend[data-id="' + LayerOptions.Id + '"]').append(mydiv);
                                        $('#legend-home div.arcgis_legend[data-id="' + LayerOptions.Id + '"]').append(mydiv);
                                    } else {
                                        var mydiv = '';
                                        mydiv += '<div><label>' + 'empty' + '</label></div>';
                                        $('#layer-home div.arcgis_legend[data-id="' + LayerOptions.Id + '"]').append(mydiv);
                                        $('#legend-home div.arcgis_legend[data-id="' + LayerOptions.Id + '"]').append(mydiv);
                                    }
                                });
                                workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, false, layer, null, 'has');
                            }
                        }
                        realindex++;
                    }
                    if (!LayerOptions.isBaseMap) {
                        myalllayers.wms.push(VectorLayer);
                    } else {
                        var myurl;
                        var ImagePath = LayerOptions.PreviewImage ? LayerOptions.PreviewImage : LayerOptions.ImagePath;

                        if (ImagePath != null) {
                            if (ImagePath.includes('Public/PreviewLayer')) {
                                ImagePath = window.rootUrl + ImagePath;
                            }
                            myurl = ImagePath;
                        } else {
                            var extt = LayerOptions.Extent.split('(')[0].split(',');
                            var epsg1 = epsg;
                            if (LayerOptions.Extent.split('(')[1]) {
                                epsg1 = LayerOptions.Extent.split('(')[1];
                            }
                            if (LayerOptions.ServerType == 'arcgis') {
                                myurl = LayerOptions.ServerURL + '/export?F=image&FORMAT=PNG32&TRANSPARENT=true&SIZE=256%2C256&BBOX=' + extt[0] + '%2C' + extt[1] + '%2C' + extt[2] + '%2C' + extt[3] + '&BBOXSR=' + epsg1 + '&IMAGESR=' + epsg1 + '&DPI=90&LAYERS=show' + encodeURI(':' + LayerOptions.Layers) + '&' + LayerOptions.AdditionalParameters;
                            }
                            else {
                                myurl = LayerOptions.ServerURL + '?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=' + LayerOptions.Layers + '&WIDTH=256&HEIGHT=256&CRS=EPSG%3A' + epsg1 + '&STYLES=&BBOX=' + extt[0] + '%2C' + extt[1] + '%2C' + extt[2] + '%2C' + extt[3] + '&' + LayerOptions.AdditionalParameters;
                            }
                        }
                        VectorLayer.set('imageUrl', myurl);
                    }
                    VectorLayer.set('IsReadOnly', LayerOptions.IsReadOnly);

                }
                else if (LayerOptions.Type === layer_types_string.LikaLayer) {

                    if (LayerOptions.zIndex) {
                        VectorLayer.setZIndex(LayerOptions.zIndex);
                    }

                    if (LayerOptions.Symbolizers) {
                        workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, true, layer);
                        realindex++;
                    }

                    var layerExtent = localStorage.getItem('local-layer-ext-' + LayerOptions.Id);
                    if (layerExtent) {
                        LayerOptions.Extent = layerExtent;
                    } else {
                        VectorLayer.set('hasToCalculateExtent', true);
                    }

                    //????
                    //var changedGoeJSON = readfeatures_with_proj('EPSG:' + epsg, 'EPSG:4326', geojsonObject, new GeoJOSNFormat());
                    //changedGoeJSON = writefeatures_with_proj('EPSG:4326', 'EPSG:4326', changedGoeJSON, new GeoJOSNFormat());
                    // makeVectorTile(undefined, JSON.parse(changedGoeJSON), VectorLayer.get('Style'));

                    myalllayers.vectore.push(VectorLayer);

                }
                else if (LayerOptions.Type === layer_types_string.PreviewLayer) {

                    if (LayerOptions.zIndex) {
                        VectorLayer.setZIndex(LayerOptions.zIndex);
                    }

                    if (LayerOptions.Symbolizers) {
                        workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, true, layer);
                        realindex++;
                    }

                    var layerExtent = localStorage.getItem('local-layer-ext-' + LayerOptions.Id);
                    if (layerExtent) {
                        LayerOptions.Extent = layerExtent;
                    } else {
                        VectorLayer.set('hasToCalculateExtent', true);
                    }

                    //????
                    //var changedGoeJSON = readfeatures_with_proj('EPSG:' + epsg, 'EPSG:4326', geojsonObject, new GeoJOSNFormat());
                    //changedGoeJSON = writefeatures_with_proj('EPSG:4326', 'EPSG:4326', changedGoeJSON, new GeoJOSNFormat());
                    // makeVectorTile(undefined, JSON.parse(changedGoeJSON), VectorLayer.get('Style'));

                    myalllayers.vectore.push(VectorLayer);

                }
                else if (LayerOptions.Type === layer_types_string.DatabaseLayer) {

                    if (LayerOptions.zIndex) {
                        VectorLayer.setZIndex(LayerOptions.zIndex);
                    }

                    if (LayerOptions.Symbolizers) {
                        workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, true, layer);
                        realindex++;
                    }

                    myalllayers.vectore.push(VectorLayer);


                }
                else if (LayerOptions.Type === layer_types_string.LinkedLayer) {

                    searchfieldsappend(VectorLayer);

                    if (LayerOptions.zIndex) {
                        VectorLayer.setZIndex(LayerOptions.zIndex);
                    }
                    VectorLayer.set('isLocal', true);
                    if (activedindex && hasModule === false && hasSelectedFeatures === false) {
                        //VectorLayer.set('isActive', true);
                        //myalllayers.isActive = VectorLayer;
                        $('#infopane-home .select-layer#' + LayerOptions.Id).click();
                        activedindex = false;
                    }
                    if (LayerOptions.Symbolizers) {
                        workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, true, layer);
                        realindex++;
                    }
                    var j = 0;
                    if (VectorLayer.getSource().getFeatures().length > 0) {
                        extent = VectorLayer.getSource().getExtent();
                        extent = bufferExtent(extent);
                    }
                    //var fieldsforsearch = [];

                    //if (LayerOptions.ServerType) {
                    //    var searchfields = LayerOptions.ServerType.split('*/');
                    //    searchfields.forEach(searchfield => {
                    //        fieldsforsearch.push({ id: searchfield.split('-')[1], aliasname: searchfield.split('-')[0] });
                    //    });
                    //}

                    //VectorLayer.set('searchFields', fieldsforsearch);

                    var vectorSource = VectorLayer.getSource();
                    //vectorSource.clear();
                    function ga() { };

                    ga('send', 'pageview');

                    let geoPackage;
                    let tableInfos;
                    var tileTables;
                    var layerType = LayerOptions.ServerType != null && LayerOptions.ServerType != '' ? LayerOptions.ServerType : LayerOptions.layerType;
                    const dataLoadTypeName = LayerOptions.ResourceType.split("-")[0];

                    if (layerType == "vector") {

                        VectorLayer.getSource().forEachFeature(feature => {
                            if (!feature.get('Id')) {

                                var fide = VectorLayer.get('AppendingFeatureId') ? VectorLayer.get('AppendingFeatureId') : 1;

                                fide++;

                                if (feature.getId()) {

                                    feature.set('Id', feature.getId())

                                } else {

                                    var props = feature.getProperties();

                                    var foundId = findIdForFeature(props, fide);

                                    feature.setId(foundId)

                                    feature.set('Id', foundId)
                                }

                                VectorLayer.set('AppendingFeatureId', fide);

                            }

                            if (feature.get('Id')) {
                                feature.setId(feature.get('Id'));
                            }

                            if (!feature.get('layerId')) {
                                feature.set('layerId', VectorLayer.get('Id'));
                            }

                        });

                        myalllayers.vectore.push(VectorLayer);

                        //var propertyArr = getUniquePropertiesAndSetLayerId(vectorSource.getFeatures(), LayerOptions, "geometry");

                        //propertyArr = propertyArr.map(p => ({ aliasname: p, id: p }));

                        //VectorLayer.set("searchFields", propertyArr);

                        //searchfieldsappend(myalllayers.isActive);
                    }

                    if (layerType == "raster") {
                        var url = "";
                        if (dataLoadTypeName == "Link") {
                            url = "https://cors-anywhere.herokuapp.com/" + LayerOptions.LinkOrPath;
                        }
                        else {
                            url = urlswithareas.Core.GetLinkedLayerFile + "?projectId=" + projectId + "&layerId=" + LayerOptions.Id;
                        }

                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'URL',
                            eventAction: 'load',
                        });

                        addProgresssBar(LayerOptions.Id);
                        //$(".progress-container").append(`
                        //    <div class="progress progress-${LayerOptions.Id}" data-done="0">
                        //        <div class="progress-bar" id="progressLinkedLayer-${LayerOptions.Id}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                        //    </div>
                        //`);

                        VectorLayer = new TileLayer({
                            visible: LayerOptions.VisibleAutmatically,
                            name: LayerOptions.Name,
                            zIndex: LayerOptions.zIndex,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            source: new XYZ()
                        });

                        myalllayers.wms.push(VectorLayer);

                        const xhr = new XMLHttpRequest();
                        xhr.open('GET', url, true);
                        xhr.responseType = 'arraybuffer';
                        xhr.onprogress = function (e) {
                            if (e.total != 0) {
                                updateProgressBarText(LayerOptions.Id, LayerOptions.Name, e.total, e.loaded);
                            }
                            else {
                                updateProgressBarTextToComplete(LayerOptions.Id, LayerOptions.Name, e.loaded);
                            }
                        }
                        xhr.onerror = function () {
                            apply404ErrorToProgressBar(LayerOptions.Id, LayerOptions.Name);
                        }
                        xhr.onload = onloadRasterGeoPackage;
                        xhr.send();
                    }

                    function getUniquePropertiesAndSetLayerId(olObject, layer, optionalExcludeProperty) {
                        var propertyArr = [];
                        olObject.forEach((e, i) => {
                            var featureProperties = e.getProperties();
                            for (key in featureProperties) {
                                if (!propertyArr.includes(key) && key != optionalExcludeProperty) {
                                    propertyArr.push(key);
                                }
                            }
                            e.set("id", i);
                            e.set("Id", i);
                            e.set("layerId", layer.Id);

                            if (LayerOptions.UseRender) {
                                e.set("renderScaleGrodan", layer.DefaultZoom);
                            }
                        });
                        return propertyArr;
                    }

                    function onloadRasterGeoPackage(e) {
                        if (e.target.status == 200 || e.target.status == 202) {
                            const uInt8Array = new Uint8Array(this.response);
                            loadByteArray(uInt8Array, LayerOptions.ServerType).then(function () {

                                applyDownloadedStyleToProgressBar(LayerOptions.Id, LayerOptions.Name);

                                if (layerType == "raster") {
                                    ga('send', {
                                        hitType: 'event',
                                        eventCategory: 'Layer',
                                        eventAction: 'load',
                                        eventLabel: 'Tile Layer',
                                    });
                                    tileTables.forEach(function (table) {
                                        const tileDao = geoPackage.getTileDao(table);
                                        var retriever = new window.GeoPackage.GeoPackageTileRetriever(tileDao, 256, 256);
                                        var tileBoundingBoxUtils = (new window.GeoPackage.TileBoundingBoxUtils()).constructor;

                                        const info = geoPackage.getInfoForTable(tileDao);
                                        const rasterProjection = (info.srs.organization + ":" + info.srs.organization_coordsys_id).toUpperCase();
                                        const linkedLayerRasterExtent = [tileDao.tileMatrixSet.min_x, tileDao.tileMatrixSet.min_y, tileDao.tileMatrixSet.max_x, tileDao.tileMatrixSet.max_y];
                                        let transformedExtent;

                                        registerProjection(rasterProjection);

                                        transformedExtent = transformExtent(linkedLayerRasterExtent, rasterProjection, mapProjection);

                                        if (checkExtentValid(transformedExtent)) {
                                            VectorLayer.setExtent(transformedExtent);
                                        }

                                        var linkedLayerRasterSource = new XYZ({
                                            wrapX: false,
                                            url: "{z},{x},{y}"
                                        });

                                        const loadFunc = (tile, src) => {
                                            let [z, x, y] = src.split(",").map(Number);
                                            //LINK
                                            var boundingBox = tileBoundingBoxUtils.getWebMercatorBoundingBoxFromXYZ(x, y, z);

                                            boundingBox = boundingBox.projectBoundingBox("EPSG:3857", mapProjection);

                                            retriever.getTileWithBounds(boundingBox, mapProjection).then((dataUri) => {
                                                if (dataUri != null) {
                                                    tile.getImage().src = dataUri;
                                                }
                                                else {
                                                    tile.getImage().src = "";
                                                }
                                            });

                                        };
                                        linkedLayerRasterSource.setTileLoadFunction(loadFunc);

                                        VectorLayer.setSource(linkedLayerRasterSource);
                                    });
                                }
                            });
                        }
                        else if (e.target.status == 403) {
                            apply403ErrorToProgressBar(LayerOptions.Id, LayerOptions.Name);
                        }
                        else { // if (xhr.status == 404)
                            apply404ErrorToProgressBar(LayerOptions.Id, LayerOptions.Name);
                        }
                    };

                    function loadByteArray(array, callback) {
                        return window.GeoPackage.GeoPackageAPI.open(array).then(function (gp) {
                            geoPackage = gp;
                            readGeoPackage(gp);
                        });
                    }

                    function readGeoPackage(geoPackage) {
                        tableInfos = {};
                        tileTables = geoPackage.getTileTables();
                        const featureTables = geoPackage.getFeatureTables();
                        featureTables.forEach(function (table) {
                            try {
                                const featureDao = geoPackage.getFeatureDao(table);
                                const info = geoPackage.getInfoForTable(featureDao);
                                tableInfos[table] = info;
                                tableNameNeededForGeoJSON = info.tableName;
                                fileProjection = info.srs.organization + ":" + info.srs.organization_coordsys_id;
                            } catch (err) {
                                console.log('Error opening table ' + table, err);
                            }
                        });
                    }
                } else if (LayerOptions.Type == layer_types_string.WFSLayer) {
                    var wfsSource;

                    var gmlFormat = new GML3();
                    var wfsversion = '2.0.0';

                    var formatqe = LayerOptions.OutputFormat.toLowerCase().includes('xml') ? new WFSFormat() : new GeoJOSNFormat();

                    if (LayerOptions.OutputFormat.toLowerCase().includes('gml')) {
                        gmlFormat = new GML32();
                        wfsversion = LayerOptions.Version;

                        if (LayerOptions.OutputFormat.includes('3.2') || LayerOptions.OutputFormat.includes('32')) {
                            gmlFormat = new GML32(); // GML 3.2
                            wfsversion = '2.0.0';
                        } else if (LayerOptions.OutputFormat.includes('3.1') || LayerOptions.OutputFormat.includes('3')) {
                            gmlFormat = new GML3(); // GML 3.1
                            //wfsversion = '1.1.0';
                            wfsversion = '2.0.0';
                        } else if (LayerOptions.OutputFormat.includes('2.1') || LayerOptions.OutputFormat.includes('2')) {
                            gmlFormat = new GML2(); // GML 2
                            wfsversion = '1.0.0';
                        } else {
                            gmlFormat = new GML(); // Default to general GML format if none match
                            wfsversion = '1.0.0';
                        }

                        formatqe = new WFSFormat({
                            gmlFormat: gmlFormat,
                            version: wfsversion
                        });
                    }

                    wfsSource = new VectorSource({
                        format: formatqe,
                        loader: function (extent, resolution, projection, success, failure) {
                            if (VectorLayer.get('HasAllFeature') === true) {
                                console.log('Skipping request, all features already loaded.');
                                success([]);
                                return;
                            }

                            var reqP = 'EPSG:' + LayerOptions.EPSG;

                            var dataP = 'EPSG:' + LayerOptions.EPSG;

                            var useGoejson = false;

                            if (LayerOptions.OutputFormat == 'GEOJSON' || LayerOptions.OutputFormat == 'application/vnd.geo+json') {
                                useGoejson = true;
                            }

                            if (useGoejson) {
                                dataP = 'EPSG:4326';
                                reqP = 'EPSG:4326';
                            }

                            var vectorSource1 = this;

                            function makeLayerInvisible() {
                                if (vectorSource1.set('SourceEndError') != true) {

                                    var activeId = $('#' + VectorLayer.get('checkbox'));

                                    var parentContainer = $(activeId).parents('div.layer-container');

                                    if (VectorLayer.get('groupLayer')) {
                                        var removedLs = VectorLayer.get('groupLayer').get('removedLayerIds') ? VectorLayer.get('groupLayer').get('removedLayerIds') : [];
                                        removedLs.push(VectorLayer.get('Id'));
                                        VectorLayer.get('groupLayer').getLayers().remove(VectorLayer);

                                        parentContainer.find('input[type="checkbox"].Layer__Checkbox').removeClass('layer' + (VectorLayer.get('groupLayer').get('Id')).replace('g', ''));
                                    } else {
                                        map.removeLayer(VectorLayer);
                                    }

                                    if (parentContainer.find('a.source-end-error').length == 0) {
                                        parentContainer.append(`<a class="source-end-error" href="javascript:void(0);" style="position:absolute; left: -1rem; top: 0.25rem;" title="${NamesForLanguages.titles.layer_backend_error}"><i class="fas fa-triangle-exclamation" style="color: rgba(255,0,0,0.5);"></i></a>`);
                                    } else {
                                    }

                                    parentContainer.find('input[type="checkbox"].Layer__Checkbox').prop('checked', false);
                                    parentContainer.find('input[type="checkbox"].Layer__Checkbox').prop('disabled', true);

                                }
                                vectorSource1.set('SourceEndError', true);
                            }

                            if (wmsLayersErrorCountVerstion == 1) {

                                var errCount = vectorSource1.get('ErrorCount');

                                if (errCount > 10) {
                                    makeLayerInvisible();
                                    failure();
                                    return null;
                                }

                            }

                            var forceStop = false;

                            if (vectorSource1.get('Extent')) {
                                //forceStop = intersects(vectorSource1.get('Extent'), extent) == false ? true : forceStop;
                            }

                            if (!forceStop) {
                                var Fextent = transformExtent(extent, mapProjection, reqP);
                                var joinedExtent = Fextent.join(',');
                                joinedExtent = Fextent[0].toFixed(20).toString() + ',' + Fextent[1].toFixed(20).toString() + ',' + Fextent[2].toFixed(20).toString() + ',' + Fextent[3].toFixed(20).toString();

                                if (useGoejson) {
                                    joinedExtent = Fextent[1] + ',' + Fextent[0] + ',' + Fextent[3] + ',' + Fextent[2];
                                }

                                var outpuFormat = 'application/json';
                                outpuFormat = encodeURI(LayerOptions.OutputFormat);

                                outpuFormat = outpuFormat.replace('+', '%2B');

                                var url = LayerOptions.ServerURL.split('?')[0] +
                                    '?service=WFS&' +
                                    'version=' + wfsversion + '&request=GetFeature&typeNames=' + LayerOptions.Layers + '&' +
                                    'outputFormat=' + outpuFormat + '&srsname=' + reqP + '&' +
                                    'bbox=' +
                                    joinedExtent +
                                    ',' + reqP + '&' + LayerOptions.AdditionalParameters;

                                var filterXml = `
                                <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                                  <ogc:PropertyIsEqualTo>
                                    <ogc:PropertyName>OBJECTID</ogc:PropertyName>
                                    <ogc:Literal>735927</ogc:Literal>
                                  </ogc:PropertyIsEqualTo>
                                </ogc:Filter>`;


                                var encodedFilter = encodeURIComponent(filterXml);


                                //url = LayerOptions.ServerURL.split('?')[0] +
                                //    '?service=WFS&' +
                                //    'version=' + LayerOptions.Version + '&request=GetFeature&typeNames=' + LayerOptions.Layers + '&' +
                                //    'outputFormat=' + outpuFormat + '&srsname=' + reqP + '&' +
                                //    'bbox=' +
                                //    joinedExtent +
                                //    ',' + reqP + '&' +
                                //    'filter=' + encodedFilter + '&' + LayerOptions.AdditionalParameters;


                                var xhr = new XMLHttpRequest();
                                xhr.open('GET', url);
                                var onError = function () {

                                    if (wmsLayersErrorCountVerstion == 1) {

                                        var ErrorCount = vectorSource1.get('ErrorCount') ? vectorSource1.get('ErrorCount') + 1 : 1;
                                        vectorSource1.removeLoadedExtent(extent);
                                        vectorSource1.set('ErrorCount', ErrorCount);

                                        if (ErrorCount > 10) {
                                            makeLayerInvisible();
                                        }

                                    }

                                    failure();
                                }
                                xhr.onerror = onError;
                                xhr.onload = function () {
                                    if (xhr.status == 200) {
                                        vectorSource1.set('ErrorCount', 0);

                                        if (outpuFormat.toLowerCase().includes('json')) {

                                            var features = readfeatures_with_proj(dataP,
                                                mapProjection, xhr.responseText, vectorSource1.getFormat());

                                            features.forEach(feature => {

                                                var fide = VectorLayer.get('AppendingFeatureId') ? VectorLayer.get('AppendingFeatureId') : 1;

                                                fide++;

                                                if (feature.getId()) {

                                                    feature.set('Id', feature.getId())

                                                } else {

                                                    var props = feature.getProperties();

                                                    var foundId = findIdForFeature(props, fide);

                                                    feature.setId(foundId)

                                                    feature.set('Id', foundId)
                                                }
                                                feature.set('layerId', LayerOptions.Id);
                                                feature.set('ProjectId', project.Id);

                                                VectorLayer.set('AppendingFeatureId', fide);
                                            });

                                            vectorSource1.addFeatures(features);

                                            success(features);

                                        } else {

                                            var features = readfeatures_with_proj(dataP,
                                                mapProjection, xhr.responseText, vectorSource1.getFormat());

                                            if (features) {

                                                if (features.length > 0) {

                                                    features.forEach(feature => {

                                                        var fide = VectorLayer.get('AppendingFeatureId') ? VectorLayer.get('AppendingFeatureId') : 1;

                                                        fide++;

                                                        if (feature.getId()) {

                                                            feature.set('Id', feature.getId())

                                                        } else {

                                                            var props = feature.getProperties();

                                                            var foundId = findIdForFeature(props, fide);

                                                            feature.setId(foundId)

                                                            feature.set('Id', foundId)
                                                        }
                                                        feature.set('layerId', LayerOptions.Id);
                                                        feature.set('ProjectId', project.Id);

                                                        VectorLayer.set('AppendingFeatureId', fide);
                                                    });

                                                    vectorSource1.addFeatures(features);

                                                }

                                                success(features);

                                            }
                                        }

                                    } else {
                                        onError();
                                    }
                                }

                                if (LayerOptions.Authorization != null && LayerOptions.Authorization != '') {
                                    xhr.setRequestHeader('Authorization', LayerOptions.Authorization);
                                }

                                xhr.send();

                            }
                        },
                        strategy: tileStrategy(createXYZ({ tileSize: 256 })),
                    });

                    VectorLayer.setSource(wfsSource);

                    if (LayerOptions.zIndex) {
                        VectorLayer.setZIndex(LayerOptions.zIndex);
                    }

                    if (LayerOptions.Symbolizers) {
                        workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, true, layer);
                        realindex++;
                    }

                    var reqP = 'EPSG:' + LayerOptions.EPSG;

                    if (LayerOptions.OutputFormat == 'GEOJSON' || LayerOptions.OutputFormat == 'application/vnd.geo+json') {
                        reqP = 'EPSG:4326';
                        epsg = 4326;
                    }

                    var outpuFormat = 'application/json';
                    outpuFormat = encodeURI(LayerOptions.OutputFormat);

                    outpuFormat = outpuFormat.replace('+', '%2B');

                    var url = LayerOptions.ServerURL.split('?')[0] +
                        '?service=WFS&' +
                        'version=' + wfsversion + '&request=GetFeature&typename=' + LayerOptions.Layers + '&' +
                        'outputFormat=' + outpuFormat + '&srsname=' + reqP + '&' + LayerOptions.AdditionalParameters;

                    VectorLayer.set('sourceUrl', url);

                    myalllayers.vectore.push(VectorLayer);
                } else if (LayerOptions.Type == layer_types_string.ArcGISLayer) {

                    var arcgisSource = new VectorSource({
                        format: new EsriJSON(),
                        //url: function (extent, resolution, projection) {
                        //    // ArcGIS Server only wants the numeric portion of the projection ID.
                        //    const srid = projection
                        //        .getCode()
                        //        .split(/:(?=\d+$)/)
                        //        .pop();

                        //    const url =
                        //        LayerOptions.ServerURL +
                        //        '/' +
                        //        LayerOptions.Layers +
                        //        '/query/?f=json&' +
                        //        'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
                        //        encodeURIComponent(
                        //            '{"xmin":' +
                        //            extent[0] +
                        //            ',"ymin":' +
                        //            extent[1] +
                        //            ',"xmax":' +
                        //            extent[2] +
                        //            ',"ymax":' +
                        //            extent[3] +
                        //            ',"spatialReference":{"wkid":' +
                        //            srid +
                        //            '}}'
                        //        ) +
                        //        '&geometryType=esriGeometryEnvelope&inSR=' +
                        //        srid +
                        //        '&outFields=*' +
                        //        '&outSR=' +
                        //        srid;

                        //    return url;
                        //},
                        loader: function (extent, resolution, projection, success, failure) {
                            if (VectorLayer.get('HasAllFeature') === true) {
                                console.log('Skipping request, all features already loaded.');
                                success([]);
                                return;
                            }

                            //var reqP = 'EPSG:' + LayerOptions.EPSG;

                            //if (LayerOptions.OutputFormat == 'GEOJSON' || LayerOptions.OutputFormat == 'application/vnd.geo+json') {
                            //    reqP = 'EPSG:4326';
                            //}

                            var vectorSource1 = this;

                            //var Fextent = transformExtent(extent, mapProjection, reqP);
                            //var joinedExtent = Fextent.join(',');
                            //joinedExtent = Fextent[0].toFixed(20).toString() + ',' + Fextent[1].toFixed(20).toString() + ',' + Fextent[2].toFixed(20).toString() + ',' + Fextent[3].toFixed(20).toString();

                            //var outpuFormat = 'application/json';
                            //outpuFormat = encodeURI(LayerOptions.OutputFormat);

                            //outpuFormat = outpuFormat.replace('+', '%2B');

                            //var url = LayerOptions.ServerURL.split('?')[0] +
                            //    '?service=WFS&' +
                            //    'version=' + LayerOptions.Version + '&request=GetFeature&typename=' + LayerOptions.Layers + '&' +
                            //    'outputFormat=' + outpuFormat + '&srsname=' + reqP + '&' +
                            //    'bbox=' +
                            //    joinedExtent +
                            //    ',' + reqP;
                            //var datenow = parseInt(Date.now() / 1000);
                            var current_stack = vectorSource1.get('moveendstacks') ?? 1;

                            if (!vectorSource1.get('current_request')) {
                                vectorSource1.set('current_request', {});
                            }

                            var forceStop = false;

                            if (vectorSource1.get('Extent')) {
                                forceStop = intersects(vectorSource1.get('Extent'), extent) == false ? true : forceStop;
                            }

                            if (!forceStop) {
                                if (!vectorSource1.get('current_request')[current_stack]) {
                                    vectorSource1.get('current_request')[current_stack] = [];
                                }
                            }

                            if (!forceStop) {

                                // ArcGIS Server only wants the numeric portion of the projection ID.
                                const srid = projection
                                    .getCode()
                                    .split(/:(?=\d+$)/)
                                    .pop();

                                const url =
                                    LayerOptions.ServerURL +
                                    '/' +
                                    LayerOptions.Layers +
                                    '/query/?f=json&' +
                                    'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
                                    encodeURIComponent(
                                        '{"xmin":' +
                                        extent[0] +
                                        ',"ymin":' +
                                        extent[1] +
                                        ',"xmax":' +
                                        extent[2] +
                                        ',"ymax":' +
                                        extent[3] +
                                        ',"spatialReference":{"wkid":' +
                                        srid +
                                        '}}'
                                    ) +
                                    '&geometryType=esriGeometryEnvelope&inSR=' +
                                    srid +
                                    '&outFields=*' +
                                    '&outSR=' +
                                    srid + '&' + LayerOptions.AdditionalParameters;

                                var xhr = new XMLHttpRequest();
                                xhr.open('GET', url);
                                var onError = function () {
                                    vectorSource1.removeLoadedExtent(extent);
                                    failure();
                                }
                                xhr.onerror = onError;
                                xhr.onabort = onError;
                                xhr.onload = function () {
                                    if (xhr.status == 200) {

                                        var features = readfeatures_with_proj('EPSG:' + srid,
                                            mapProjection, xhr.responseText, vectorSource1.getFormat());

                                        features.forEach(feature => {

                                            var fide = VectorLayer.get('AppendingFeatureId') ? VectorLayer.get('AppendingFeatureId') : 1;

                                            fide++;

                                            if (feature.getId()) {

                                                feature.set('Id', feature.getId())

                                            } else {

                                                var props = feature.getProperties();

                                                var foundId = findIdForFeature(props, fide);

                                                feature.setId(foundId)

                                                feature.set('Id', foundId)
                                            }
                                            feature.set('layerId', LayerOptions.Id);
                                            feature.set('ProjectId', project.Id);

                                            VectorLayer.set('AppendingFeatureId', fide);
                                        });

                                        vectorSource1.addFeatures(features);

                                        success(features);

                                    } else {
                                        onError();
                                    }
                                }

                                if (LayerOptions.Authorization != null && LayerOptions.Authorization != '') {
                                    xhr.setRequestHeader('Authorization', LayerOptions.Authorization);
                                }

                                xhr.send();

                                vectorSource1.get('current_request')[current_stack].push({ xhr: xhr, ext: extent });
                            }
                        },
                        strategy: tileStrategy(
                            createXYZ({
                                tileSize: 512,
                            })
                        ),
                        attributions:
                            'University of Leicester (commissioned by the ' +
                            '<a href="https://www.arcgis.com/home/item.html?id=' +
                            'd5f05b1dc3dd4d76906c421bc1727805">National Trust</a>)',
                    });

                    arcgisSource.set('moveendstacks', 1);

                    //map.on('moveend', function () {
                    //    var current_stack = arcgisSource.get('moveendstacks') ?? 1;
                    //    var mapExt = map.getView().calculateExtent();
                    //    if (arcgisSource.get('current_request')[current_stack - 1]) {
                    //        arcgisSource.get('current_request')[current_stack - 1].forEach(xhrObj => {
                    //            if (intersects(mapExt, xhrObj['ext']) == false) {
                    //                //xhrObj['xhr'].abort();
                    //            }
                    //        });
                    //        delete arcgisSource.get('current_request')[current_stack - 1];
                    //    }

                    //    arcgisSource.set('moveendstacks', (arcgisSource.get('moveendstacks') ? arcgisSource.get('moveendstacks') + 1 : 2));
                    //});

                    VectorLayer.setSource(arcgisSource);

                    if (LayerOptions.zIndex) {
                        VectorLayer.setZIndex(LayerOptions.zIndex);
                    }

                    if (LayerOptions.Symbolizers) {
                        workwithsymbolizers(LayerOptions.Symbolizers, VectorLayer, realindex, LayerOptions.Name, true, layer);
                        realindex++;
                    }

                    var srid = LayerOptions.EPSG;

                    var extent = LayerOptions.Extent.split(',');

                    var url =
                        LayerOptions.ServerURL +
                        '/' +
                        LayerOptions.Layers +
                        '/query/?f=json&' +
                        'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
                        encodeURIComponent(
                            '{"xmin":' +
                            extent[0] +
                            ',"ymin":' +
                            extent[1] +
                            ',"xmax":' +
                            extent[2] +
                            ',"ymax":' +
                            extent[3] +
                            ',"spatialReference":{"wkid":' +
                            srid +
                            '}}'
                        ) +
                        '&geometryType=esriGeometryEnvelope&inSR=' +
                        srid +
                        '&outFields=*' +
                        '&outSR=' +
                        srid + '&' + LayerOptions.AdditionalParameters;

                    VectorLayer.set('sourceUrl', url);

                    var url1 =
                        LayerOptions.ServerURL +
                        '/' +
                        LayerOptions.Layers +
                        '/getEstimates?f=json' + '&' + LayerOptions.AdditionalParameters;

                    VectorLayer.set('getEstimateUrl', url1);

                    var url2 =
                        LayerOptions.ServerURL +
                        '/' +
                        LayerOptions.Layers +
                        '?f=json' + '&' + LayerOptions.AdditionalParameters;

                    VectorLayer.set('getFeatureServerUrl', url2);

                    myalllayers.vectore.push(VectorLayer);
                }

                //ImageLayer
                //const activeImageLayer = ImageTile == 'True';
                const activeImageLayer = true;
                const calculateTileImageFromOtherZooms = false;

                if (LayerOptions.Type != layer_types_string.ServiceLayer && LayerOptions.ImagePath && LayerOptions.UseImageLayer == true && activeImageLayer && LayerOptions.Extent) {

                    var thisextent = LayerOptions.Extent.split('(')[0];
                    var thisepsg = LayerOptions.Extent.split('(')[1] ? LayerOptions.Extent.split('(')[1] : epsg;
                    var extent12 = $.map(thisextent.split(','), function (value) {
                        return parseFloat(value);
                    });

                    registerProjection('EPSG:' + thisepsg);
                    var mynewextentproj112 = thisepsg == '3857' ? extent12 : transformExtent(extent12, 'EPSG:' + thisepsg, 'EPSG:3857');
                    mynewextentproj112 = mapProjection == 'EPSG:3857' ? mynewextentproj112 : transformExtent(mynewextentproj112, 'EPSG:3857', mapProjection);
                    mynewextentproj112 = bufferExtent(mynewextentproj112);
                    var maxRes = getResFromScale(LayerOptions.MaxScale, (new getCenter(mynewextentproj112)), undefined, map);
                    var tileScale = LayerOptions.DefaultZoom;
                    tileScale = LayerOptions.TileZoom ? LayerOptions.TileZoom : tileScale;
                    var minRes = getResFromScale(tileScale, (new getCenter(mynewextentproj112)), undefined, map);

                    var imagePathIs = LayerOptions.ImagePath.includes('DataWarehouse/Tiles/') || LayerOptions.ImagePath.includes('Documents/DBLayers/');

                    if (imagePathIs && LayerOptions.ImagePath.includes('{z}/{x}/{y}.png')) {
                        const imageUrl = LayerOptions.ImagePath;
                        const UseDirectLink = false;

                        if (LayerOptions.UsedLevels == null) {
                            LayerOptions.UsedLevels = '';
                        }

                        var arr = LayerOptions.UsedLevels.split(',').map(value => { return isNaN(parseInt(value)) ? 0 : parseInt(value) });
                        var MaxLevel = Math.max(...arr);
                        var imageSource = new XYZ({
                            tileUrlFunction: function (coordinate) {
                                var vers = this.get('cacheVersion');
                                if (UseDirectLink) {
                                    var newURL = imageUrl;
                                    newURL = newURL.replace('{z}', coordinate[0]);
                                    newURL = newURL.replace('{x}', coordinate[1]);
                                    newURL = newURL.replace('{y}', coordinate[2]);
                                    return newURL;
                                } else {
                                    if (PublicMap == true) {
                                        return window.rootUrl + 'Public/GetTileImage?LayerId=' + LayerOptions.Id + '&z=' + (coordinate[0]) + '&x=' + coordinate[1] + '&y=' + coordinate[2] + '&ProjectId=' + project.Id + '&maxLevel=' + MaxLevel + '&cacheV=' + vers;
                                    } else {
                                        return window.rootUrl + 'Datawarehouse/GetTileImage?LayerId=' + LayerOptions.Id + '&z=' + (coordinate[0]) + '&x=' + coordinate[1] + '&y=' + coordinate[2] + '&maxLevel=' + MaxLevel + '&IsChecked=' + calculateTileImageFromOtherZooms + '&cacheV=' + vers;
                                    }
                                }
                            },
                            //cacheSize: 128
                        });

                        imageSource.set('cacheVersion', 1);

                        VectorLayer.set('MaxLevel', MaxLevel);

                        Array.prototype.remove = function () {
                            var what, a = arguments, L = a.length, ax;
                            while (L && this.length) {
                                what = a[--L];
                                while ((ax = this.indexOf(what)) !== -1) {
                                    this.splice(ax, 1);
                                }
                            }
                            return this;
                        };

                        arr = arr.remove(0);
                        VectorLayer.set('UsedLevels', arr);

                        if (LayerOptions.UsedLevels && false) {
                            var resos = LayerOptions.UsedLevels.split(',');
                            //VectorLayer.set('maxLevel', resos[resos.length - 1]);
                            if (resos.length > 0) {
                                //if (!imageSource.getTileGrid().tileSizes_) {
                                //    imageSource.getTileGrid().tileSizes_ = [];
                                //}
                                //resos.forEach((zoo, ind1) => {
                                //    if (zoo != '') {
                                //        imageSource.getTileGrid().tileSizes_[zoo] = 256;
                                //        if (resos[ind1 - 1]) {
                                //            imageSource.getTileGrid().resolutions_.forEach((reso, ind) => {
                                //                if (ind < zoo && ind > resos[ind1 - 1]) {
                                //                    var size = 256 / Math.pow(2, parseInt(parseInt(zoo) - ind));
                                //                    imageSource.getTileGrid().tileSizes_[ind] = size;
                                //                }
                                //            });
                                //        } else {
                                //            imageSource.getTileGrid().resolutions_.forEach((reso, ind) => {
                                //                if (ind < zoo) {
                                //                    var size = 256 / Math.pow(2, parseInt(parseInt(zoo) - ind));
                                //                    imageSource.getTileGrid().tileSizes_[ind] = size;
                                //                }
                                //            });
                                //        }
                                //    } else {
                                //        imageSource.getTileGrid().resolutions_.forEach((reso, ind) => {
                                //            if (ind > resos[ind1 - 1]) {
                                //                var size = 256 * (Math.pow(2, parseInt(ind-parseInt(resos[ind1 - 1]))));
                                //                imageSource.getTileGrid().tileSizes_[ind] = size;
                                //            }
                                //        });
                                //    }
                                //});
                                imageSource.getTileGrid().resolutions_.forEach((reso, ind) => {

                                    //if (!imageSource.getTileGrid().tileSizes_) {
                                    //    imageSource.getTileGrid().tileSizes_ = [];
                                    //}
                                    //imageSource.getTileGrid().tileSizes_[ind] = 256;

                                    //if (resos[0] > ind) {
                                    //    var size = 256 * Math.pow(2, parseInt(parseInt(resos[0]) - ind));
                                    //    imageSource.getTileGrid().tileSizes_[ind] = size;
                                    //}

                                    //if (resos[0] < ind && resos[resos.length - 1] > ind) {
                                    if (!resos.includes(ind.toString())) {
                                        imageSource.getTileGrid().resolutions_[ind] = undefined;
                                    } else {

                                        //}
                                    }
                                });
                            }
                            console.log(imageSource.getTileGrid())
                        }

                        var imageLayer = new TileLayer({
                            source: imageSource,
                            visible: LayerOptions.VisibleAutmatically,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            Transparency: LayerOptions.Transparency,
                            projection: 'EPSG:' + thisepsg,
                            extent: mynewextentproj112
                        });

                        imageSource.on('tileloadstart', function () {
                            progress.addLoading();
                        });

                        imageSource.on('tileloadend', function () {
                            progress.addLoaded();
                        });
                        imageSource.on('tileloaderror', function () {
                            progress.addLoaded();
                        });

                        imageLayer.set('maxScale', LayerOptions.MaxScale);
                        imageLayer.set('minScale', tileScale);
                        VectorLayer.set('imageLayer', imageLayer);
                        LayerOptions.MaxScale = tileScale;

                    }
                    else if (imagePathIs && LayerOptions.ImagePath.includes('{z}_{x}_{y}.png')) {

                        var oldjsondata = JSON.parse(LayerOptions.ImagePath);

                        const tileSizes = oldjsondata['size'];

                        var counts = oldjsondata['count'];

                        var resolutionss = oldjsondata['resolutions'];

                        var resolutions = [], matrixIds = [], tileSizes1 = [], tileCounts = [];

                        const imageUrl = oldjsondata['imageUrl'];

                        var extentTry = oldjsondata['extent'];

                        if (extentTry) {
                            var thisextent1 = extentTry.split('(')[0];
                            var thisepsg1 = extentTry.split('(')[1] ? extentTry.split('(')[1] : epsg;
                            extent12 = $.map(thisextent1.split(','), function (value) {
                                return parseFloat(value);
                            });
                            mynewextentproj112 = thisepsg1 == '3857' ? extent12 : transformExtent(extent12, 'EPSG:' + thisepsg1, 'EPSG:3857');
                            mynewextentproj112 = mapProjection == 'EPSG:3857' ? mynewextentproj112 : transformExtent(mynewextentproj112, 'EPSG:3857', mapProjection);
                        }

                        const projectionExtent = extent12;

                        const UseDirectLink = false;

                        $.each(tileSizes, (index, value) => {
                            tileSizes1[index] = value;
                            resolutions[index] = resolutionss[index];
                            matrixIds[index] = index;
                            tileCounts[index] = counts[index];
                        });

                        var tileGrid = new TileGrid({
                            origin: getTopLeft(projectionExtent),
                            resolutions: resolutions,
                            matrixIds: matrixIds,
                            sizes: tileCounts,
                            tileSizes: tileSizes1
                        });

                        var imageSource = new TileImageSource({
                            tileGrid: tileGrid,
                            url: '',
                            projection: 'EPSG:' + thisepsg,
                            imageExtent: extent12,
                            tileUrlFunction: function (coordinate) {
                                if (UseDirectLink) {
                                    var newURL = imageUrl;
                                    newURL = newURL.replace('{z}', coordinate[0]);
                                    newURL = newURL.replace('{x}', coordinate[1]);
                                    newURL = newURL.replace('{y}', coordinate[2]);
                                    return window.rootUrl + newURL;
                                } else {
                                    if (PublicMap == true) {
                                        return window.rootUrl + 'Public/GetTileImage?LayerId=' + LayerOptions.Id + '&z=' + coordinate[0] + '&x=' + coordinate[1] + '&y=' + coordinate[2] + '&ProjectId=' + project.Id;
                                    } else {
                                        return window.rootUrl + 'Datawarehouse/GetTileImage?LayerId=' + LayerOptions.Id + '&z=' + coordinate[0] + '&x=' + coordinate[1] + '&y=' + coordinate[2];
                                    }
                                }
                            },
                            cacheSize: 128,
                            imageSmoothing: true,
                        });

                        var imageLayer = new TileLayer({
                            source: imageSource,
                            visible: LayerOptions.VisibleAutmatically,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            Transparency: LayerOptions.Transparency,
                            projection: 'EPSG:' + thisepsg
                        });

                        imageSource.on('tileloadstart', function () {
                            progress.addLoading();
                        });

                        imageSource.on('tileloadend', function () {
                            progress.addLoaded();
                        });
                        imageSource.on('tileloaderror', function () {
                            progress.addLoaded();
                        });

                        imageLayer.set('maxScale', LayerOptions.MaxScale);
                        imageLayer.set('minScale', tileScale);
                        VectorLayer.set('imageLayer', imageLayer);
                        LayerOptions.MaxScale = tileScale;

                    }
                    else if (imagePathIs) {

                        var oldjsondata = JSON.parse(LayerOptions.ImagePath);
                        const tileSize = oldjsondata['size'];
                        const count = oldjsondata['count'];
                        const imageUrl = oldjsondata['imageUrl'];

                        const UseDirectLink = false;

                        const projectionExtent = extent12;
                        var resolutions = [], matrixIds = [], sizes = [];

                        var diff = (LayerOptions.MaxScale - tileScale) / 5;
                        for (var i = 0; i <= 4; i++) {
                            var l = 4 - i;
                            matrixIds[l] = l;
                            resolutions[l] = getResFromScale(tileScale + (diff * i), getCenter(extent12), getProj('EPSG:' + thisepsg));
                            sizes[l] = [count - 1, count - 1];
                        }

                        var tileGrid = new TileGrid({
                            origin: getTopLeft(projectionExtent),
                            resolutions: resolutions,
                            matrixIds: matrixIds,
                            sizes: sizes,
                            tileSize: tileSize
                        });

                        var imageSource = new TileImageSource({
                            tileGrid: tileGrid,
                            url: '',
                            projection: 'EPSG:' + thisepsg,
                            imageExtent: extent12,
                            tileUrlFunction: function (coordinate) {
                                if (coordinate[1] >= 0 && coordinate[2] >= 0 && coordinate[1] < count && coordinate[2] < count) {
                                    if (UseDirectLink) {
                                        var newURL = imageUrl;
                                        newURL = newURL.replace('{x}', coordinate[1]);
                                        newURL = newURL.replace('{y}', coordinate[2]);
                                        return window.rootUrl + newURL;
                                    } else {
                                        if (PublicMap == true) {
                                            return window.rootUrl + 'Public/GetTileImage?LayerId=' + LayerOptions.Id + '&x=' + coordinate[1] + '&y=' + coordinate[2] + '&ProjectId=' + project.Id;
                                        } else {
                                            return window.rootUrl + 'Datawarehouse/GetTileImage?LayerId=' + LayerOptions.Id + '&x=' + coordinate[1] + '&y=' + coordinate[2];
                                        }
                                    }
                                }
                            },
                            cacheSize: 128,
                            imageSmoothing: false,
                        });

                        var imageLayer = new TileLayer({
                            source: imageSource,
                            visible: LayerOptions.VisibleAutmatically,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            Transparency: LayerOptions.Transparency,
                            projection: 'EPSG:' + thisepsg
                        });

                        imageLayer.set('maxScale', LayerOptions.MaxScale);
                        imageLayer.set('minScale', tileScale);
                        VectorLayer.set('imageLayer', imageLayer);
                        LayerOptions.MaxScale = tileScale;

                    }
                    else if (LayerOptions.ImagePath.includes('size') && LayerOptions.ImagePath.includes('v:1.0.1')) {
                        var oldjsondata = JSON.parse(LayerOptions.ImagePath);
                        var jsondata = {};
                        $.each(oldjsondata, (index, mydata) => {
                            if (index != 'size' && index != 'count' && index != 'resolutions') {
                                var myindex1 = parseInt(index.split('_')[0].replace(/^\D+/g, ''));
                                var myindex2 = parseInt(index.split('_')[1].replace(/^\D+/g, ''));
                                var myindex3 = parseInt(index.split('_')[2].replace(/^\D+/g, ''));
                                jsondata[myindex1] = jsondata[myindex1] ? jsondata[myindex1] : {};
                                jsondata[myindex1][myindex2] = jsondata[myindex1][myindex2] ? jsondata[myindex1][myindex2] : {};
                                jsondata[myindex1][myindex2][myindex3] = mydata;
                            }
                        });
                        const tileSizes = oldjsondata['size'];
                        var counts = oldjsondata['count'];
                        var resolutionss = oldjsondata['resolutions'];
                        const projectionExtent = extent12;
                        var resolutions = [], matrixIds = [], tileSizes1 = [], tileCounts = [];
                        $.each(tileSizes, (index, value) => {
                            tileSizes1[index] = value;
                            resolutions[index] = resolutionss[index];
                            matrixIds[index] = index;
                            tileCounts[index] = counts[index];
                        });

                        var tileGrid = new TileGrid({
                            origin: getTopLeft(projectionExtent),
                            resolutions: resolutions,
                            matrixIds: matrixIds,
                            sizes: tileCounts,
                            tileSizes: tileSizes1
                        });

                        var imageSource = new TileImageSource({
                            tileGrid: tileGrid,
                            url: '',
                            projection: 'EPSG:' + thisepsg,
                            imageExtent: extent12,
                            tileUrlFunction: function (coordinate) {
                                if (coordinate[1] >= 0 && coordinate[2] >= 0) {
                                    if (jsondata[coordinate[0]]) {
                                        if (jsondata[coordinate[0]][coordinate[1]]) {
                                            return (jsondata[coordinate[0]][coordinate[1]][coordinate[2]]);
                                        }
                                    }
                                }
                            },
                            cacheSize: 128,
                            imageSmoothing: false,
                        });

                        var imageLayer = new TileLayer({
                            source: imageSource,
                            visible: LayerOptions.VisibleAutmatically,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            Transparency: LayerOptions.Transparency,
                            projection: 'EPSG:' + thisepsg
                        });

                        imageLayer.set('maxScale', LayerOptions.MaxScale);
                        imageLayer.set('minScale', tileScale);
                        VectorLayer.set('imageLayer', imageLayer);
                        LayerOptions.MaxScale = tileScale;

                    }
                    else if (LayerOptions.ImagePath.includes('size')) {
                        var oldjsondata = JSON.parse(LayerOptions.ImagePath);
                        var jsondata = {};
                        $.each(oldjsondata, (index, mydata) => {
                            if (index != 'size' && index != 'count') {
                                var myindex1 = parseInt(index.split('_')[0].replace(/^\D+/g, ''));
                                var myindex2 = parseInt(index.split('_')[1].replace(/^\D+/g, ''));
                                jsondata[myindex1] = jsondata[myindex1] ? jsondata[myindex1] : {};
                                jsondata[myindex1][myindex2] = mydata;
                            }
                        });

                        const tileSize = oldjsondata['size'];
                        var count = (Object.keys(jsondata).length);
                        const projectionExtent = extent12;
                        var resolutions = [];
                        resolutions[1] = getResFromScale(tileScale, getCenter(extent12), getProj('EPSG:' + thisepsg));

                        var tileGrid = new TileGrid({
                            origin: getTopLeft(projectionExtent),
                            resolutions: resolutions,
                            matrixIds: [1],
                            sizes: [count],
                            tileSize: tileSize
                        });

                        var imageSource = new TileImageSource({
                            tileGrid: tileGrid,
                            url: '',
                            projection: 'EPSG:' + thisepsg,
                            imageExtent: extent12,
                            tileUrlFunction: function (coordinate) {
                                if (coordinate[1] >= 0 && coordinate[2] >= 0) {
                                    if (jsondata[coordinate[1]]) {
                                        return (jsondata[coordinate[1]][coordinate[2]]);
                                    }
                                }
                            },
                            cacheSize: 128,
                            imageSmoothing: false,
                        });

                        var imageLayer = new TileLayer({
                            source: imageSource,
                            visible: LayerOptions.VisibleAutmatically,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            Transparency: LayerOptions.Transparency,
                            projection: 'EPSG:' + thisepsg
                        });

                        imageLayer.set('maxScale', LayerOptions.MaxScale);
                        imageLayer.set('minScale', tileScale);
                        VectorLayer.set('imageLayer', imageLayer);
                        LayerOptions.MaxScale = tileScale;

                    }
                    else if (LayerOptions.ImagePath.includes('map0_0')) {
                        var oldjsondata = JSON.parse(LayerOptions.ImagePath);
                        var jsondata = {};
                        $.each(oldjsondata, (index, mydata) => {
                            var myindex1 = parseInt(index.split('_')[0].replace(/^\D+/g, ''));
                            var myindex2 = parseInt(index.split('_')[1].replace(/^\D+/g, ''));
                            jsondata[myindex1] = jsondata[myindex1] ? jsondata[myindex1] : {};
                            jsondata[myindex1][myindex2] = mydata;
                        });
                        var Imagelayers = [];
                        var count = (Object.keys(jsondata).length);
                        const diffrence = (extent12[2] - extent12[0]) / count;
                        var XC = 0;
                        $.each(jsondata, (ind, datas) => {
                            var Xmin, Xmax;
                            var YC = 0;
                            Xmin = extent12[0] + (XC * diffrence);
                            Xmax = Xmin + diffrence;
                            $.each(datas, (ind1, data) => {
                                var Ymin, Ymax;
                                Ymax = extent12[3] - (YC * diffrence);
                                Ymin = Ymax - diffrence;
                                var thisextent1 = [Xmin, Ymin, Xmax, Ymax];
                                var imageSource = new ImageStatic({
                                    url: data,
                                    projection: 'EPSG:' + thisepsg,
                                    imageExtent: thisextent1,
                                    imageSmoothing: false,
                                    //imageLoadFunction: function (image, src) {
                                    //    image.getImage().src = data;
                                    //}
                                });
                                var imageLayer = new ImageLayer({
                                    source: imageSource,
                                    //minResolution: minRes,
                                    //maxResolution: maxRes,
                                    visible: true
                                });
                                Imagelayers.push(imageLayer);
                                YC++;
                            });
                            XC++;
                        });

                        var imageLayersGroup = new LayerGroup({
                            visible: LayerOptions.VisibleAutmatically,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            opacity: LayerOptions.Transparency,
                            layers: Imagelayers
                        });

                        imageLayersGroup.set('maxScale', LayerOptions.MaxScale);
                        imageLayersGroup.set('minScale', tileScale);
                        VectorLayer.set('imageLayer', imageLayersGroup);
                        LayerOptions.MaxScale = tileScale;
                    }
                    else if (LayerOptions.ImagePath.includes('{"0":{"0":')) {
                        var jsondata = JSON.parse(LayerOptions.ImagePath);
                        var Imagelayers = [];
                        var count = (Object.keys(jsondata).length);
                        const diffrence = (extent12[2] - extent12[0]) / count;
                        var XC = 0;
                        $.each(jsondata, (ind, datas) => {
                            var Xmin, Xmax;
                            var YC = 0;
                            Xmin = extent12[0] + (XC * diffrence);
                            Xmax = Xmin + diffrence;
                            $.each(datas, (ind1, data) => {
                                var Ymin, Ymax;
                                Ymax = extent12[3] - (YC * diffrence);
                                Ymin = Ymax - diffrence;
                                var thisextent1 = [Xmin, Ymin, Xmax, Ymax];
                                var imageSource = new ImageStatic({
                                    url: data,
                                    projection: 'EPSG:' + thisepsg,
                                    imageExtent: thisextent1,
                                    //imageLoadFunction: function (image, src) {
                                    //    image.getImage().src = data;
                                    //}
                                });
                                var imageLayer = new ImageLayer({
                                    source: imageSource,
                                    //minResolution: minRes,
                                    //maxResolution: maxRes,
                                    visible: true
                                });
                                Imagelayers.push(imageLayer);
                                YC++;
                            });
                            XC++;
                        });

                        var imageLayersGroup = new LayerGroup({
                            visible: LayerOptions.VisibleAutmatically,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            opacity: LayerOptions.Transparency,
                            layers: Imagelayers
                        });

                        imageLayersGroup.set('maxScale', LayerOptions.MaxScale);
                        imageLayersGroup.set('minScale', tileScale);
                        VectorLayer.set('imageLayer', imageLayersGroup);
                        LayerOptions.MaxScale = tileScale;

                    }
                    else {
                        var imageSource = new ImageStatic({
                            url: LayerOptions.ImagePath,
                            projection: 'EPSG:' + thisepsg,
                            imageExtent: extent12,
                            imageLoadFunction: function (image, src) {
                                image.getImage().src = src;
                            }
                        });

                        var imageLayer = new ImageLayer({
                            source: imageSource,
                            visible: LayerOptions.VisibleAutmatically,
                            minResolution: minRes,
                            maxResolution: maxRes,
                            Transparency: LayerOptions.Transparency
                        });

                        imageLayer.set('maxScale', LayerOptions.MaxScale);
                        imageLayer.set('minScale', tileScale);
                        VectorLayer.set('imageLayer', imageLayer);
                        LayerOptions.MaxScale = tileScale;
                    }
                }

                //GeoJSONTile
                if (LayerOptions.GeoJSONTile && LayerOptions.DataLoadTypeName == 'Extent' && activeImageLayer && LayerOptions.UseImageLayer == true) {
                    var thisextent = LayerOptions.Extent.split('(')[0];
                    var thisepsg = LayerOptions.Extent.split('(')[1] ? LayerOptions.Extent.split('(')[1] : epsg;
                    var extent12 = $.map(thisextent.split(','), function (value) {
                        return parseFloat(value);
                    });
                    var mynewextentproj112 = thisepsg == '3857' ? extent12 : transformExtent(extent12, 'EPSG:' + thisepsg, 'EPSG:3857');
                    mynewextentproj112 = mapProjection == 'EPSG:3857' ? mynewextentproj112 : transformExtent(mynewextentproj112, 'EPSG:3857', mapProjection);
                    var maxRes = getResFromScale(LayerOptions.MaxScale, (new getCenter(mynewextentproj112)), undefined, map);
                    var minRes = getResFromScale(LayerOptions.MinScale, (new getCenter(mynewextentproj112)), undefined, map);
                    var jsondata = JSON.parse(LayerOptions.GeoJSONTile);
                    if (jsondata['imageUrl'].includes('{z}_{x}_{y}.geojson')) {

                        const useImageTile = true;
                        if (useImageTile) {

                            var oldjsondata = JSON.parse(LayerOptions.GeoJSONTile);
                            const tileSizes = oldjsondata['size'];
                            var counts = oldjsondata['count'];
                            var resolutionss = oldjsondata['resolutions'];
                            var resolutions = [], matrixIds = [], tileSizes1 = [], tileCounts = [];
                            const imageUrl = oldjsondata['imageUrl'];
                            var extentTry = oldjsondata['extent'];
                            if (extentTry) {
                                var thisextent1 = extentTry.split('(')[0];
                                var thisepsg1 = extentTry.split('(')[1] ? extentTry.split('(')[1] : epsg;
                                extent12 = $.map(thisextent1.split(','), function (value) {
                                    return parseFloat(value);
                                });
                                mynewextentproj112 = thisepsg1 == '3857' ? extent12 : transformExtent(extent12, 'EPSG:' + thisepsg1, 'EPSG:3857');
                                mynewextentproj112 = mapProjection == 'EPSG:3857' ? mynewextentproj112 : transformExtent(mynewextentproj112, 'EPSG:3857', mapProjection);
                            }
                            const projectionExtent = extent12;

                            const UseDirectLink = false;

                            $.each(tileSizes, (index, value) => {
                                tileSizes1[index] = value;
                                resolutions[index] = resolutionss[index];
                                matrixIds[index] = index;
                                tileCounts[index] = counts[index];
                            });

                            var tileGrid = new TileGrid({
                                origin: getTopLeft(projectionExtent),
                                resolutions: resolutions,
                                matrixIds: matrixIds,
                                sizes: tileCounts,
                                tileSizes: tileSizes1
                            });

                            var imageSource = new TileImageSource({
                                tileGrid: tileGrid,
                                url: '',
                                projection: 'EPSG:' + thisepsg,
                                imageExtent: extent12,
                                tileUrlFunction: function (coordinate) {
                                    if (UseDirectLink) {

                                    } else {
                                        var url = window.rootUrl + 'Datawarehouse/GetTileGeojson';
                                        if (PublicMap == true) {
                                            url = window.rootUrl + 'Public/GetTileGeojson';
                                        }
                                        $.ajax({
                                            url: url,
                                            //cache: false,
                                            data: {
                                                LayerId: LayerOptions.Id,
                                                z: coordinate[0],
                                                x: coordinate[1],
                                                y: coordinate[2],
                                                projectId: project.Id
                                            },
                                            success: function (html) {
                                                if (html != null && html != "") {
                                                    var featureString = html.split('=')[1].split(',thisdataGrodan')[0];
                                                    var geojson = JSON.parse(featureString);
                                                    var features = readfeatures_with_proj('EPSG:3857',
                                                        mapProjection, geojson, new GeoJOSNFormat());
                                                    features.forEach((feature) => {

                                                        var fide = VectorLayer.get('AppendingFeatureId') ? VectorLayer.get('AppendingFeatureId') : 1;

                                                        fide++;

                                                        if (feature.getId()) {

                                                            feature.set('Id', feature.getId())

                                                        } else {

                                                            var props = feature.getProperties();

                                                            var foundId = findIdForFeature(props, fide);

                                                            feature.setId(foundId)

                                                            feature.set('Id', foundId)
                                                        }

                                                        feature.set('layerId', LayerOptions.Id)
                                                        feature.set('ProjectId', project.Id);

                                                        VectorLayer.set('AppendingFeatureId', fide);
                                                    });
                                                    VectorLayer.getSource().addFeatures(features);
                                                }
                                            }
                                        });
                                    }
                                },
                                cacheSize: 128,
                                imageSmoothing: true,
                            });

                            var imageLayer = new TileLayer({
                                source: imageSource,
                                visible: LayerOptions.VisibleAutmatically,
                                minResolution: minRes,
                                maxResolution: maxRes,
                                Transparency: LayerOptions.Transparency,
                                projection: 'EPSG:' + thisepsg
                            });

                            imageSource.on('tileloadstart', function () {
                                progress.addLoading();
                            });

                            imageSource.on('tileloadend', function () {
                                progress.addLoaded();
                            });
                            imageSource.on('tileloaderror', function () {
                                progress.addLoaded();
                            });

                            imageLayer.set('maxScale', LayerOptions.MaxScale);
                            imageLayer.set('minScale', LayerOptions.MinScale);
                            VectorLayer.set('geojsonTileLayer', imageLayer);
                        }
                        else {
                            var oldjsondata = JSON.parse(LayerOptions.GeoJSONTile);
                            const tileSizes = oldjsondata['size'];
                            var counts = oldjsondata['count'];
                            var resolutionss = oldjsondata['resolutions'];
                            var resolutions = [], matrixIds = [], tileSizes1 = [], tileCounts = [];
                            const imageUrl = oldjsondata['imageUrl'];
                            var extentTry = oldjsondata['extent'];
                            if (extentTry) {
                                var thisextent1 = extentTry.split('(')[0];
                                var thisepsg1 = extentTry.split('(')[1] ? extentTry.split('(')[1] : epsg;
                                extent12 = $.map(thisextent1.split(','), function (value) {
                                    return parseFloat(value);
                                });
                                mynewextentproj112 = thisepsg1 == '3857' ? extent12 : transformExtent(extent12, 'EPSG:' + thisepsg1, 'EPSG:3857');
                                mynewextentproj112 = mapProjection == 'EPSG:3857' ? mynewextentproj112 : transformExtent(mynewextentproj112, 'EPSG:3857', mapProjection);
                            }
                            const projectionExtent = extent12;

                            const UseDirectLink = false;

                            $.each(tileSizes, (index, value) => {
                                tileSizes1[index] = value;
                                resolutions[index] = resolutionss[index];
                                matrixIds[index] = index;
                                tileCounts[index] = counts[index];
                            });

                            var tileGrid = new TileGrid({
                                origin: getTopLeft(projectionExtent),
                                resolutions: resolutions,
                                matrixIds: matrixIds,
                                sizes: tileCounts,
                                tileSizes: tileSizes1
                            });

                            var imageSource = new VectorTile({
                                tileGrid: tileGrid,
                                url: '',
                                projection: 'EPSG:' + thisepsg,
                                extent: extent12,
                                tileUrlFunction: function (coordinate) {
                                },
                                cacheSize: 128,
                                //format: new GeoJOSNFormat()
                            });

                            var imageLayer = new TileLayer({
                                source: imageSource,
                                visible: LayerOptions.VisibleAutmatically,
                                minResolution: minRes,
                                maxResolution: maxRes,
                                Transparency: LayerOptions.Transparency,
                                projection: 'EPSG:' + thisepsg
                            });

                            imageLayer.set('maxScale', LayerOptions.MaxScale);
                            imageLayer.set('minScale', LayerOptions.MinScale);
                            VectorLayer.set('geojsonTileLayer', imageLayer);
                        }
                    }
                    else if (jsondata['imageUrl'].includes('extent.geojson')) {
                        VectorLayer.set('geojsonFeatureCount', jsondata['count']);
                        VectorLayer.set('geojsonExtentLayer', true);
                    }
                }

                var impossibellayers = ['Bosch Text', 'Flurstücknummer m1', 'Flurstücknummer m2', 'Hausnummer m1', 'Hausnummer m2', 'Name m1', 'Name m2'];

                var labellayersDataLocations = ['lika.BoSch_Text', 'lika.FlurstNr_M1', 'lika.FlurstNr_M2', 'lika.HausNr_M1', 'lika.HausNr_M2', 'lika.Name_M1', 'lika.Name_M2', 'lika.SonstText_M1', 'lika.SonstText_M2', 'lika.NutzText']

                if (LayerOptions.IsReadOnly) {
                    VectorLayer.set('IsReadOnly', LayerOptions.IsReadOnly);
                }

                if (LayerOptions.Type == layer_types_string.LikaLayer) {
                    var thislocations = LayerOptions.DataLocation.split('.');
                    var thislocate = thislocations[1] + '.' + thislocations[2];
                    if (labellayersDataLocations.includes(thislocate)) {
                        myalllayers.vectore.pop();
                        //VectorLayer.set('IsReadOnly', true);
                        myalllayers.label.push(VectorLayer);
                        LayerOptions.IsReadOnly = true;
                    }
                } else if (LayerOptions.Type == layer_types_string.PreviewLayer) {

                } else {
                    //if (impossibellayers.includes(LayerOptions.NameField)) {
                    //    myalllayers.vectore.pop();
                    //    //VectorLayer.set('IsReadOnly', true);
                    //    myalllayers.label.push(VectorLayer);
                    //    //LayerOptions.IsReadOnly = true;
                    //}
                }

                if (LayerOptions.DataLoadTypeName === 'Extent' /*&& LayerOptions.Type != 'LinkedLayer'*/) {
                    VectorLayer.set('isMoveEnd', true);
                }

                VectorLayer.set('EPSG', epsg);

                if (LayerOptions.Extent && LayerOptions.Extent != ',,,') {

                    try {

                        var myproj11 = 'EPSG:' + LayerOptions.EPSG;
                        var thisextent = LayerOptions.Extent.split('(')[0];
                        var epsg1 = epsg;
                        if (LayerOptions.Extent.split('(')[1]) {
                            if (getProj('EPSG:' + epsg) == null) {
                                var text = allProjs['EPSG:' + epsg];
                                proj4defs('EPSG:' + epsg, text);
                                proj4register(proj4);
                            }
                            epsg1 = LayerOptions.Extent.split('(')[1];
                        }
                        myproj11 = 'EPSG:' + epsg1;

                        var mylaextent11 = thisextent.split(',');
                        if (mylaextent11.length == 4) {

                            mylaextent11.forEach((string, ind) => {
                                mylaextent11[ind] = parseFloat(string);
                            });

                            if (epsg1 == '4326'/* && LayerOptions.Type === 'Service'*/) {
                                //mylaextent11 = [mylaextent11[1], mylaextent11[0], mylaextent11[3], mylaextent11[2]]
                            }

                            if (getProj(myproj11) != null) {

                                var mynewextentproj11;
                                //???????

                                //console.log(LayerOptions)

                                if (mapProjection != 'EPSG:3857' && myproj11 != 'EPSG:3857') {
                                    mynewextentproj11 = transformExtent(mylaextent11, myproj11, 'EPSG:3857');
                                    mynewextentproj11 = transformExtent(mynewextentproj11, 'EPSG:3857', mapProjection);
                                } else {
                                    mynewextentproj11 = transformExtent(mylaextent11, myproj11, mapProjection);
                                }

                                if (checkExtentValid(mynewextentproj11)) {

                                    if (LayerOptions.Type != layer_types_string.DatabaseLayer && LayerOptions.Type != layer_types_string.ModuleLayer && LayerOptions.Type != layer_types_string.ToolLayer) {
                                        VectorLayer.setExtent(mynewextentproj11);

                                        VectorLayer.getSource().set('Extent', mynewextentproj11);
                                    }

                                    VectorLayer.set('Extent', mynewextentproj11);

                                    if (hasModule === false && hasSelectedFeatures === false) {
                                        extentToZoom = bufferExtent(mynewextentproj11);
                                    }
                                }

                            } else {
                                var text = allProjs[myproj11];
                                if (text) {
                                    proj4defs(myproj11, text);
                                    proj4register(proj4);

                                    var mynewextentproj11;

                                    //???????
                                    if (mapProjection != 'EPSG:3857' && myproj11 != 'EPSG:3857') {
                                        mynewextentproj11 = transformExtent(mylaextent11, myproj11, 'EPSG:3857');
                                        mynewextentproj11 = transformExtent(mynewextentproj11, 'EPSG:3857', mapProjection);
                                    } else {
                                        mynewextentproj11 = transformExtent(mylaextent11, myproj11, mapProjection);
                                    }

                                    if (checkExtentValid(mynewextentproj11)) {

                                        if (LayerOptions.Type != layer_types_string.DatabaseLayer && LayerOptions.Type != layer_types_string.ModuleLayer && LayerOptions.Type != layer_types_string.ToolLayer) {
                                            VectorLayer.setExtent(mynewextentproj11);

                                            VectorLayer.getSource().set('Extent', mynewextentproj11);
                                        }
                                        VectorLayer.set('Extent', mynewextentproj11);
                                        if (hasModule === false && hasSelectedFeatures === false) {
                                            extentToZoom = bufferExtent(mynewextentproj11);
                                        }
                                        var zoomtodiv = document.createElement('div');
                                        zoomtodiv.title = NamesForLanguages.titles.zoomTo;

                                        zoomtodiv.setAttribute('data-layerId', VectorLayer.get('Id'));

                                        zoomtodiv.className = 'tool-div zoomto';
                                        var zoomtoi = document.createElement('i');
                                        zoomtoi.className = 'fas fa-search-location';
                                        zoomtodiv.append(zoomtoi);
                                        $('#layer-home div[data-id="' + LayerOptions.Id + '"] div.tool-div:first').before(zoomtodiv);
                                        $(zoomtodiv).on('click', () => {
                                            var extent1 = VectorLayer.getExtent();
                                            var extent2 = [...extent1];
                                            extent2 = bufferExtent(extent2);
                                            map.getView().fit(extent2);
                                        });

                                    }
                                } else {
                                    $.get(',' + epsg1 + '.proj4', function (res) {
                                        proj4defs('EPSG:' + epsg1, res);
                                        proj4register(proj4);

                                        var mynewextentproj11;

                                        //???????
                                        if (mapProjection != 'EPSG:3857' && myproj11 != 'EPSG:3857') {
                                            mynewextentproj11 = transformExtent(mylaextent11, myproj11, 'EPSG:3857');
                                            mynewextentproj11 = transformExtent(mynewextentproj11, 'EPSG:3857', mapProjection);
                                        } else {
                                            mynewextentproj11 = transformExtent(mylaextent11, myproj11, mapProjection);
                                        }

                                        if (checkExtentValid(mynewextentproj11)) {

                                            if (LayerOptions.Type != layer_types_string.DatabaseLayer && LayerOptions.Type != layer_types_string.ModuleLayer && LayerOptions.Type != layer_types_string.ToolLayer) {
                                                VectorLayer.setExtent(mynewextentproj11);

                                                VectorLayer.getSource().set('Extent', mynewextentproj11);
                                            }

                                            VectorLayer.set('Extent', mynewextentproj11);
                                            var zoomtodiv = document.createElement('div');
                                            zoomtodiv.title = NamesForLanguages.titles.zoomTo;

                                            zoomtodiv.setAttribute('data-layerId', VectorLayer.get('Id'));

                                            zoomtodiv.className = 'tool-div zoomto';
                                            var zoomtoi = document.createElement('i');
                                            zoomtoi.className = 'fas fa-search-location';
                                            zoomtodiv.append(zoomtoi);
                                            $('#layer-home div[data-id="' + LayerOptions.Id + '"] div.tool-div:first').before(zoomtodiv);
                                            $(zoomtodiv).on('click', () => {
                                                var extent1 = VectorLayer.getExtent();
                                                var extent2 = [...extent1];
                                                extent2 = bufferExtent(extent2);
                                                map.getView().fit(extent2);
                                            });

                                        }
                                    });
                                }
                            }
                        } else {

                            VectorLayer.set('hasToCalculateExtent', true);

                        }
                    } catch (e) {

                        VectorLayer.set('hasToCalculateExtent', true);

                    }

                } else {
                    VectorLayer.set('hasToCalculateExtent', true);
                }

                if (VectorLayer.get('HeatMapLayer')) {

                    //console.log($('#layer-home div[data-indx="' + LayerOptions.Id + '"] div.tool-div'))

                    //$('#layer-home div[data-indx="' + LayerOptions.Id + '"] div.tool-div').css('display','none');

                    //$('#layer-home div[data-indx="' + LayerOptions.Id + '"] label.legendlabel').css('display','none');

                    //$('#legend-layer-' + LayerOptions.Id).remove();

                    myalllayers.vectore.pop();
                    var props = VectorLayer.getProperties();
                    VectorLayer = VectorLayer.get('HeatMapLayer');
                    VectorLayer.setProperties(props);
                    myalllayers.vectore.push(VectorLayer);

                    if (hasSelectedFeatures === false && localMapData) {
                        if (LayerOptions.Id == localMapData['activeLayer']) {
                            myalllayers['isActive'] = VectorLayer;
                        }
                    }

                }

                if (LayerOptions.Selected) {
                    if (VectorLayer.get('Extent')) {
                        map.getView().fit(VectorLayer.get('Extent'));
                        hasSelectedFeatures = true;
                    }
                }

                if (hasModule === false && hasSelectedFeatures === false && VectorLayer.getSource().getExtent) {
                    var mynewexr = (VectorLayer.getSource().getExtent());
                    if (mynewexr[0] != Infinity) {
                        extentToZoom = bufferExtent(mynewexr);
                    }
                }

                var maxRes = getResFromScale(LayerOptions.MaxScale, undefined, undefined, map);
                var minRes = getResFromScale(LayerOptions.MinScale, undefined, undefined, map);
                if (VectorLayer.getExtent && VectorLayer.getExtent()) {
                    if (VectorLayer.getExtent()[0] != Infinity) {
                        var center = new getCenter(VectorLayer.getExtent());
                        maxRes = getResFromScale(LayerOptions.MaxScale, center, undefined, map);
                        minRes = getResFromScale(LayerOptions.MinScale, center, undefined, map);
                    }
                } else if (VectorLayer.getSource().getExtent) {
                    if (VectorLayer.getSource().getExtent()) {
                        if (VectorLayer.getSource().getExtent()[0] != Infinity) {
                            var center = new getCenter(VectorLayer.getSource().getExtent());
                            maxRes = getResFromScale(LayerOptions.MaxScale, center, undefined, map);
                            minRes = getResFromScale(LayerOptions.MinScale, center, undefined, map);
                        }
                    }
                }

                if (maxRes) {
                    VectorLayer.set('maxResolution', maxRes);
                    VectorLayer.set('maxScale', LayerOptions.MaxScale);
                }
                if (minRes) {
                    VectorLayer.set('minResolution', minRes);
                    VectorLayer.set('minScale', LayerOptions.MinScale);
                }

                VectorLayer.set('Id', LayerOptions.Id);
                VectorLayer.set('id', LayerOptions.Id);
                VectorLayer.set('AppId', LayerOptions.ApplicationId);
                VectorLayer.set('Type', LayerOptions.Type);
                VectorLayer.set('Name', LayerOptions.Name);

                if (metadataV1) {
                    VectorLayer.set('Description', LayerOptions.Description);
                }

                VectorLayer.set('AliasName', LayerOptions.Name);
                VectorLayer.set('GrodanTitle', LayerOptions.SearchFieldTitle);
                VectorLayer.set('DataLocation', LayerOptions.DataLocation);
                VectorLayer.set('LayerContent', LayerOptions.StyleContent);
                VectorLayer.set('Transparency', LayerOptions.Transparency);
                VectorLayer.set('IsReadOnly', LayerOptions.IsReadOnly);
                VectorLayer.set('UseRender', LayerOptions.UseRender);
                VectorLayer.set('renderScaleGrodan', (LayerOptions.DefaultZoom != null ? LayerOptions.DefaultZoom : 1000));
                VectorLayer.set('ServerType', LayerOptions.ServerType);
                VectorLayer.set('Editable', LayerOptions.Editable);
                VectorLayer.set('isDrawable', LayerOptions.Editable);
                VectorLayer.set('isBaseMap', LayerOptions.isBaseMap);

                VectorLayer.set('TitleString', LayerOptions.TitleString);
                VectorLayer.set('ProjectId', LayerOptions.ProjectId);

                VectorLayer.set('yeymapsLayerType', LayerOptions.Type);

                try {
                    VectorLayer.set('PreviewFieldNames', LayerOptions.PreviewFieldNames.split(','));
                } catch (e) {

                }

                VectorLayer.set('hasIntrinsic', LayerOptions.hasIntrinsic);

                var settingsPermission = false;
                if (LayerOptions.ApplicationUserRole) {
                    if (LayerOptions.ApplicationUserRole['PermissionLayer']['CanEditLayerSettings'] == true) {
                        settingsPermission = true;
                    } else if (LayerOptions.ApplicationUserRole['PermissionLayer']['CanSeeLayerSettings'] == true) {
                        settingsPermission = true;
                    }
                }

                if (LayerOptions.Type == layer_types_string.DatabaseLayer || LayerOptions.Type == layer_types_string.ToolLayer || LayerOptions.Type == layer_types_string.ModuleLayer) {
                    VectorLayer.set('Extent', null);
                    VectorLayer.set('hasToCalculateExtent', true);
                }

                var drawPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanDraw'] : false;
                var editPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanEdit'] : false;
                var modifyPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanModify'] : false;
                var deletePermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanDelete'] : false;


                if (LayerOptions.Type == "LinkedLayer") {
                    drawPermission = false;
                    editPermission = false;
                    deletePermission = false;
                    modifyPermission = false;
                }

                var Permission = {
                    Create: drawPermission,
                    Edit: editPermission,
                    Delete: deletePermission,
                    Modify: modifyPermission,
                    Settings: settingsPermission
                };

                VectorLayer.set('TextSymbolizerPropertyName', LayerOptions.TextSymbolizerPropertyName ?? "");
                VectorLayer.set('CategorizedFieldPropertyName', LayerOptions.CategorizedFieldPropertyName ?? "");

                VectorLayer.set('Permission', Permission);
                VectorLayer.set('NoAccess', LayerOptions.noPermission);

                VectorLayer.set('InfoFields', LayerOptions.InfoFields);
                VectorLayer.set('TitleValue', LayerOptions.TitleValue);

                if (selectedIds != null) {
                    try {

                        var url = window.rootUrl + 'Projects/GetFeaturesInExtent';
                        var operationParameter = selectedIds.join(',');
                        var filterquery = ' {{Id Replace}} IN(' + operationParameter + ') ';

                        // If you want to create a new file
                        var newfile = new Blob([filterquery], { type: 'text/plain' });

                        var formData = new FormData();
                        formData.append('layerId', LayerOptions.Id);  // Add the layer ID to the form data
                        formData.append('projectId', project.Id);     // Add the project ID to the form data
                        formData.append('file', newfile);  // Add the file from an input field (myFileInput is the input element ID)

                        $.ajax({
                            type: "POST",  // Change the request type to POST for file upload
                            url: url,      // URL for the request
                            data: formData,
                            processData: false,  // Prevent jQuery from processing the data
                            contentType: false,  // Prevent jQuery from setting the content type (it will be set automatically by FormData)
                            success: function (html) {
                                if (html != null && html !== "" && html !== '"fail"') {
                                    try {
                                        var featureString = html.split('mydata =')[1].split(',thisdataGrodan')[0];
                                        var searchResult = [];

                                        var geojsons = JSON.parse(featureString);
                                        RecievedGeojsonToFeaturesAddToLayer(VectorLayer, geojsons, null, function (feature) {
                                            if (VectorLayer.get("DataLocation").includes("cemetery.Burials")) {
                                                if (selectedIds.includes(feature.get('Id').toString())) {
                                                    searchResult.push(feature);

                                                    if (ZoomTo) {
                                                        if (ZoomTo['layerId'] == LayerOptions.Id && ZoomTo['Id'] != null) {

                                                            if (ZoomTo['Id'] == feature.get('Id')) {
                                                                zoomToFeature(feature, '', map, null);
                                                            }

                                                        }
                                                    }

                                                    //if (zoomToResult) {
                                                    //    zoomToFeature(feature, '', map, null);
                                                    //}
                                                } else {
                                                    //console.log(feature)
                                                }
                                            } else {
                                                searchResult.push(feature);

                                                if (ZoomTo) {
                                                    if (ZoomTo['layerId'] == LayerOptions.Id && ZoomTo['Id'] != null) {

                                                        if (ZoomTo['Id'] == feature.get('Id')) {
                                                            zoomToFeature(feature, '', map, null);
                                                        }

                                                    }
                                                }
                                            }
                                        });

                                        if (VectorLayer.get("DataLocation").includes("cemetery.Burials")) {

                                            //console.log(searchResult)
                                            select_inter_source.addFeatures(searchResult);

                                            if (selectedFeatures[VectorLayer.get('Id')]) {
                                                selectedFeatures[VectorLayer.get('Id')]['features'] = searchResult;
                                            } else {
                                                selectedFeatures[VectorLayer.get('Id')] = {
                                                    Id: VectorLayer.get('Id'),
                                                    name: VectorLayer.get('Name'),
                                                    DataLocation: VectorLayer.get('DataLocation'),
                                                    AppId: VectorLayer.get('AppId')
                                                };
                                                selectedFeatures[VectorLayer.get('Id')]['features'] = searchResult;
                                            }

                                            append_all_selected_features(selectedFeatures, true, true, true);
                                            $('a#infopane-tab').click();

                                            //searchInLayer(LayerOptions.Id, operationParameter, false, "id", {
                                            //    zoomToTheResult: true,
                                            //    targetLayer: VectorLayer,
                                            //    preventSavingCache: true
                                            //});

                                        } else {

                                            select_inter_source.addFeatures(searchResult);

                                            if (selectedFeatures[VectorLayer.get('Id')]) {
                                                selectedFeatures[VectorLayer.get('Id')]['features'] = searchResult;
                                            } else {
                                                selectedFeatures[VectorLayer.get('Id')] = {
                                                    Id: VectorLayer.get('Id'),
                                                    name: VectorLayer.get('Name'),
                                                    DataLocation: VectorLayer.get('DataLocation'),
                                                    AppId: VectorLayer.get('AppId')
                                                };
                                                selectedFeatures[VectorLayer.get('Id')]['features'] = searchResult;
                                            }

                                            append_all_selected_features(selectedFeatures, true, true, true);
                                            $('a#infopane-tab').click();

                                        }

                                        if (ZoomTo) {
                                            if (ZoomTo['layerId'] == LayerOptions.Id && ZoomTo['Id'] == null) {

                                                var extent11 = select_inter_source.getExtent();
                                                extent11 = bufferExtent(extent11);
                                                if (extent11[0] != Infinity) {

                                                    map.getView().fit(extent11);
                                                    if (hasSelectedFeatures === false) {

                                                        hasSelectedFeatures = true;
                                                        extentToZoom = extent11;
                                                    }
                                                }

                                            }
                                        }

                                    } catch (e) {
                                        console.error('Error parsing GeoJSON:', e);
                                    }
                                }
                            },
                            error: function (xhr, status, error) {
                                console.error('Request failed:', status, error);
                            }
                        });


                        //deveverAjax({
                        //    type: "GET",
                        //    url: url,
                        //    data: {
                        //        layerId: LayerOptions.Id,
                        //        projectId: project.Id,
                        //        //FilterQueryString: ' {{Id Replace}} IN(' + operationParameter + ') ',
                        //    },
                        //    dataType: 'text',
                        //    success: function (html) {
                        //        if (html != null && html != "" && html != '"fail"') {
                        //            var featureString = html.split('mydata =')[1].split(',thisdataGrodan')[0];
                        //            var geojsons = JSON.parse(featureString);
                        //            RecievedGeojsonToFeaturesAddToLayer(VectorLayer, geojsons, null);

                        //            searchInLayer(LayerOptions.Id, operationParameter, false, "id", {
                        //                zoomToTheResult: true,
                        //                targetLayer: VectorLayer,
                        //                preventSavingCache: true
                        //            });
                        //        }
                        //    }
                        //});
                    } catch (e) {
                        console.error(e);
                    }
                }

            } catch (e) {

                console.error(e)

                VectorLayer.set('Id', LayerOptions.Id);
                VectorLayer.set('id', LayerOptions.Id);
                VectorLayer.set('AppId', LayerOptions.ApplicationId);
                VectorLayer.set('Type', LayerOptions.Type);
                VectorLayer.set('Name', LayerOptions.Name);

                if (metadataV1) {
                    VectorLayer.set('Description', LayerOptions.Description);
                }

                VectorLayer.set('AliasName', LayerOptions.Name);
                VectorLayer.set('GrodanTitle', LayerOptions.SearchFieldTitle);
                VectorLayer.set('DataLocation', LayerOptions.DataLocation);
                VectorLayer.set('LayerContent', LayerOptions.StyleContent);
                VectorLayer.set('Transparency', LayerOptions.Transparency);
                VectorLayer.set('IsReadOnly', LayerOptions.IsReadOnly);
                VectorLayer.set('UseRender', LayerOptions.UseRender);
                VectorLayer.set('renderScaleGrodan', (LayerOptions.DefaultZoom != null ? LayerOptions.DefaultZoom : 1000));
                VectorLayer.set('ServerType', LayerOptions.ServerType);
                VectorLayer.set('Editable', LayerOptions.Editable);
                VectorLayer.set('isDrawable', LayerOptions.Editable);
                VectorLayer.set('isBaseMap', LayerOptions.isBaseMap);

                VectorLayer.set('TitleString', LayerOptions.TitleString);
                VectorLayer.set('ProjectId', LayerOptions.ProjectId);

                VectorLayer.set('yeymapsLayerType', LayerOptions.Type);
                VectorLayer.set('PreviewFieldNames', LayerOptions.PreviewFieldNames);

                var settingsPermission = false;
                if (LayerOptions.ApplicationUserRole) {
                    if (LayerOptions.ApplicationUserRole['PermissionLayer']['CanEditLayerSettings'] == true) {
                        settingsPermission = true;
                    } else if (LayerOptions.ApplicationUserRole['PermissionLayer']['CanSeeLayerSettings'] == true) {
                        settingsPermission = true;
                    }
                }

                var drawPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanDraw'] : false;
                var editPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanEdit'] : false;
                var modifyPermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanModify'] : false;
                var deletePermission = LayerOptions.ApplicationUserRole ? LayerOptions.ApplicationUserRole['PermissionLayer']['CanDelete'] : false;

                if (LayerOptions.Type == "LinkedLayer") {
                    drawPermission = false;
                    editPermission = false;
                    deletePermission = false;
                    modifyPermission = false;
                }

                var Permission = {
                    Create: drawPermission,
                    Edit: editPermission,
                    Delete: deletePermission,
                    Modify: modifyPermission,
                    Settings: settingsPermission
                };

                VectorLayer.set('TextSymbolizerPropertyName', LayerOptions.TextSymbolizerPropertyName ?? "");
                VectorLayer.set('CategorizedFieldPropertyName', LayerOptions.CategorizedFieldPropertyName ?? "");
                VectorLayer.set('Permission', Permission);
                VectorLayer.set('NoAccess', LayerOptions.noPermission);
                VectorLayer.set('brokenLayer', true);
            }

        }

        return VectorLayer;
    }
